var nurseslounge_myDashboard_schedule = {
    serverDateHelper:null,
    serverDate:null,
    selectedView:'month',
    selectedDate:null,
    setServerDate:function($utcDate){
        this.serverDateHelper = new Date();
        this.serverDate = $utcDate.toDate();
    },
    getServerDate:function(){
        var $now  = new Date().getTime();
        var $diff = $now - this.serverDateHelper.getTime();
        var $date = this.serverDate.getTime() + $diff;
        $date = new Date($date);
        return {
            Y: $date.getUTCFullYear(),
            n: $date.getUTCMonth(),
            d: $date.getUTCDate(),
            G: $date.getUTCHours(),
            i: $date.getUTCMinutes(),
            s: $date.getUTCSeconds(),
            v: $date.getUTCMilliseconds()
        };
    },
    open_my_calendar:function($params){
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_myDashboard_camera.init($params);
        nurseslounge_myDashboard.submenu($params, function(){
            setTimeout(function(){
                var $myCalendar = $("#nurseslounge-home-my-calendar");
                var $timeZone = $myCalendar.find(".time-zone");
                var $area = $timeZone.data('area');
                $params = $.extend({}, $params, {area:$area});
                nurseslounge_myDashboard_myCalendar.open_my_calendar_request($params, function($data){
                    var $momentDate = moment($data.data.star_at);
                    $params = $.extend({}, $params, {month:$momentDate.clone().format('DD-MM-YYYY')});
                    nurseslounge_myDashboard_myCalendar.get($params, function($data){
                        nurseslounge_myDashboard_myCalendar.createCalendar('week', $momentDate.clone(), $data);
                    });
                });
            }, 1000);
        });
    },
    open_my_calendar_request:function($params, cback){
        $.ajax({
            url: "/myDashboard/myCalendar/getEventMoment",
            method: 'POST',
            cache: false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    init: function ($params) {
        nurseslounge_myDashboard_schedule.schedule($params);
    },
    schedule:function($params){
        nurseslounge_myDashboard_schedule.currentTime();
        var $myCalendar = $("#nurseslounge-home-schedule");
        var $timeZone = $myCalendar.find(".time-zone");
        var $area = $timeZone.data('area');
        nurseslounge_myDashboard_schedule.selectedDate = moment();
        var $calendarDate = nurseslounge_myDashboard_schedule.selectedDate;
        var $defaulCalendar = nurseslounge_myDashboard_schedule.selectedView;
        switch ($defaulCalendar) {
            case 'month':{
                $params = $.extend({}, $params, {area:$area, month:$calendarDate.clone().format('DD-MM-YYYY')});
                break;
            }
            case 'week':{
                $params = $.extend({}, $params, {area:$area, week:$calendarDate.clone().format('DD-MM-YYYY')});
                break;
            }
            case 'day':{
                $params = $.extend({}, $params, {area:$area, week:$calendarDate.clone().format('DD-MM-YYYY')});
                break;
            }
            case 'list':{
                $params = $.extend({}, $params, {area:$area, week:$calendarDate.clone().format('DD-MM-YYYY')});
                break;
            }
        }
        nurseslounge_myDashboard_schedule.get($params, function($data){
            var $weeks = nurseslounge_myDashboard_schedule.getWeeks($calendarDate, $data);
            var $week = $calendarDate.clone().week();
            var $day = $calendarDate.clone().format('DD');
            $day = libs.pad('00',$day,'l');
            var $currentWeek = $weeks.filter(function($v){
                return $v[0] == $week;
            })[0];
            var $currentDay = $currentWeek[1].filter(function($v){
                return $v[0] == $day;
            })[0];
            var $Y = $currentDay[1].trace.year.Y;
            var $n = $currentDay[1].trace.month.n - 1;
            var $d = $currentDay[1].trace.day.d;
            var $G = $currentDay[1].trace.hour.G;
            var $i = $currentDay[1].trace.hour.i;
            var $s = $currentDay[1].trace.hour.s;
            var $v = $currentDay[1].trace.hour.v;
            var $utcDate = moment.utc([$Y, $n, $d, $G, $i, $s, $v]);
            nurseslounge_myDashboard_schedule.setServerDate($utcDate);
            nurseslounge_myDashboard_schedule.createCalendar($defaulCalendar, $calendarDate.clone(), $data);
        });
    },
    currentTime:function(){
        var $myCalendar = $("#nurseslounge-home-schedule");
        var $calendarBinding = libs.memoryGet('myDashboard_schedule_current_time') ? libs.memoryGet('myDashboard_schedule_current_time') : null;
        var $now = moment();
        var $dateArea = moment.tz.guess();
        var $dateZone = moment($now.format('YYYY-MM-DD')).tz($dateArea).format('Z');
        var $dateZoneAbbr = moment($now.format('YYYY-MM-DD')).tz($dateArea).format('z');
        var $timeZone = $myCalendar.find(".time-zone");
        var $timeNow = $myCalendar.find(".time-now");
        $timeZone.data('area', $dateArea);
        $timeZone.data('zone', $dateZone);
        $timeZone.data('zoneabbr', $dateZoneAbbr);
        $timeZone.html($dateArea+' '+$dateZone+' '+$dateZoneAbbr);
        $timeNow.data('datetime', $now.format('DD-MM-YYYY, HH:mm:ss'));

        var $activeTimeLine = $(".calendar .view-week .week-timeline.active");
        var $viewWeek = $activeTimeLine.parent();
        var $from = $viewWeek.data('from');
        $from = moment($from, 'YYYY-MM-DD HH:mm:ss');
        var $diffInMinutes = $now.diff($from, 'minutes');
        var $top = (parseInt($diffInMinutes)*2);
        var $getTop = $activeTimeLine.css('top');
        $getTop = $getTop!= undefined ? $getTop.replace('px', '') : '';
        if($getTop != $top){
            $activeTimeLine.css('top', $top);
        }

        var $weekTimeline = libs.memoryGet('myDashboard_shedule_week_timeline_binding');
        if($diffInMinutes == 0 && !$weekTimeline){
            libs.memorySave('myDashboard_schedule_week_timeline_binding', true);
            $activeTimeLine.removeClass('active');
            var $index = $($activeTimeLine.parents('tr:first').find('td')).index($viewWeek);
            $activeTimeLine.parent().closest('tr').next('tr').find('td:eq('+$index+')').find('.week-timeline').addClass('active');
            libs.memorySave('myDashboard_shedule_week_timeline_binding', false);
        }

        $timeNow.html($now.format('MMMM DD YYYY, hh:mm:ss a')).promise().done(function(){
            try{
                clearTimeout($calendarBinding);
            }catch ($e) {

            }
            $calendarBinding = setTimeout(function(){
                nurseslounge_myDashboard_schedule.currentTime();
            }, 1000);
        });
        libs.memorySave('myDashboard_schedule_current_time', $calendarBinding)
    },
    get:function($params, cback){
        $.ajax({
            url: "/myDashboard/schedule/get",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    createCalendar:function($view, $momentDate, $data){
        var $userId = libs.memoryGet('user_id');
        var $myCalendar = $("#nurseslounge-home-schedule");
        var $timeZone = $myCalendar.find(".time-zone");
        var $area = $timeZone.data('area');
        var $viewOptions = $myCalendar.find(".view-options");
        var $prevButton = $myCalendar.find(".prev-button");
        var $nextButton = $myCalendar.find(".next-button");
        var $todayButton = $myCalendar.find(".today-button");
        var $createEvent = $myCalendar.find(".create-event");
        var $YYYY = $momentDate.format('YYYY');
        var $MMMM = $momentDate.format('MMMM');
        var $calendarTitle = $myCalendar.find(".calendar-title");
        var $calendarTop = $("#nurseslounge-home-schedule .nurseslounge-home-schedule-top");
        nurseslounge_myDashboard_schedule.selectedDate = $momentDate;
        switch ($view) {
            case 'month':{
                $calendarTop.find(".event-list-text").html('Event List View').promise().done(function(){
                    $calendarTop.find(".event-list-text").data('event','list');
                    nurseslounge_myDashboard_schedule.createCalendarMonth($momentDate, $data);
                });
                break;
            }
            case 'week':{
                $calendarTop.find(".event-list-text").html('Event Calendar View').promise().done(function(){
                    $calendarTop.find(".event-list-text").data('event','month');
                    nurseslounge_myDashboard_schedule.createCalendarWeek($momentDate, $data);
                });
                break;
            }
            case 'day':{
                $calendarTop.find(".event-list-text").html('Event Calendar View').promise().done(function(){
                    $calendarTop.find(".event-list-text").data('event','month');
                    nurseslounge_myDashboard_schedule.createCalendarDay($momentDate, $data);
                });
                break;
            }
            case 'list':{
                $calendarTop.find(".event-list-text").html('Event Calendar View').promise().done(function(){
                    $calendarTop.find(".event-list-text").data('event','month');
                    nurseslounge_myDashboard_schedule.createCalendarList($momentDate, $data);
                });
                break;
            }
        }
        $calendarTitle.removeClass('calendar-title-preload');
        $calendarTitle.html($MMMM+' - '+$YYYY).promise().done(function(){
            $viewOptions.unbind().change(function(){
                var $that = $(this);
                var $selectedView = $that.val();
                var $params = {user_id:$userId, area:$area};
                var $selectedDate = nurseslounge_myDashboard_schedule.selectedDate;
                if($selectedView != ''){
                    switch ($selectedView) {
                        case 'month':{
                            $params = $.extend({}, $params, {month:$selectedDate.clone().format('DD-MM-YYYY')});
                            break;
                        }
                        case 'week':{
                            $params = $.extend({}, $params, {week:$selectedDate.clone().format('DD-MM-YYYY')});
                            break;
                        }
                        case 'day':{
                            $params = $.extend({}, $params, {week:$selectedDate.clone().format('DD-MM-YYYY')});
                            break;
                        }
                        case 'list':{
                            $params = $.extend({}, $params, {week:$selectedDate.clone().format('DD-MM-YYYY')});
                            break;
                        }
                    }
                    nurseslounge_myDashboard_schedule.get($params, function($data){
                        nurseslounge_myDashboard_schedule.createCalendar($selectedView, $selectedDate.clone(), $data);
                    });
                    nurseslounge_myDashboard_schedule.selectedView = $selectedView;
                }
            });
            $viewOptions.find('option[value="'+$view+'"]').prop('selected', true);
            $prevButton.unbind().click(function(){
                var $newMomentDate = null;
                var $selectedView = nurseslounge_myDashboard_schedule.selectedView;
                var $params = {user_id:$userId, area:$area};
                switch ($selectedView) {
                    case 'month':{
                        $newMomentDate = $momentDate.subtract(1, 'month');
                        $params = $.extend({}, $params, {month:$newMomentDate.clone().format('DD-MM-YYYY')});
                        break;
                    }
                    case 'week':{
                        $newMomentDate = $momentDate.subtract(1, 'week');
                        $params = $.extend({}, $params, {week:$newMomentDate.clone().format('DD-MM-YYYY')});
                        break;
                    }
                    case 'day':{
                        $newMomentDate = $momentDate.subtract(1, 'day');
                        $params = $.extend({}, $params, {week:$newMomentDate.clone().format('DD-MM-YYYY')});
                        break;
                    }
                    case 'list':{
                        $newMomentDate = $momentDate.subtract(1, 'day');
                        $params = $.extend({}, $params, {week:$newMomentDate.clone().format('DD-MM-YYYY')});
                        break;
                    }
                }
                nurseslounge_myDashboard_schedule.get($params, function($data){
                    nurseslounge_myDashboard_schedule.createCalendar($selectedView, $newMomentDate.clone(), $data);
                });
                nurseslounge_myDashboard_schedule.selectedView = $selectedView;
            });
            $nextButton.unbind().click(function(){
                var $newMomentDate = null;
                var $selectedView = nurseslounge_myDashboard_schedule.selectedView;
                var $params = {user_id:$userId, area:$area};
                switch ($selectedView) {
                    case 'month':{
                            $newMomentDate = $momentDate.add(1, 'month');
                            $params = $.extend({}, $params, {month:$newMomentDate.clone().format('DD-MM-YYYY')});
                        break;
                    }
                    case 'week':{
                            $newMomentDate = $momentDate.add(1, 'week');
                            $params = $.extend({}, $params, {week:$newMomentDate.clone().format('DD-MM-YYYY')});
                        break;
                    }
                    case 'day':{
                            $newMomentDate = $momentDate.add(1, 'day');
                            $params = $.extend({}, $params, {week:$newMomentDate.clone().format('DD-MM-YYYY')});
                        break;
                    }
                    case 'list':{
                            $newMomentDate = $momentDate.add(1, 'day');
                            $params = $.extend({}, $params, {week:$newMomentDate.clone().format('DD-MM-YYYY')});
                        break;
                    }
                }
                nurseslounge_myDashboard_schedule.get($params, function($data){
                    nurseslounge_myDashboard_schedule.createCalendar($selectedView, $newMomentDate.clone(), $data);
                });
                nurseslounge_myDashboard_schedule.selectedView = $selectedView;
            });
            $todayButton.unbind().click(function(){
                var $selectedView = nurseslounge_myDashboard_schedule.selectedView;
                var $params = {user_id:$userId, area:$area};
                var $today = moment();
                switch ($selectedView) {
                    case 'month':{
                        $params = $.extend({}, $params, {month:$today.clone().format('DD-MM-YYYY')});
                        break;
                    }
                    case 'week':{
                        $params = $.extend({}, $params, {week:$today.clone().format('DD-MM-YYYY')});
                        break;
                    }
                    case 'day':{
                        $params = $.extend({}, $params, {week:$today.clone().format('DD-MM-YYYY')});
                        break;
                    }
                    case 'list':{
                        $params = $.extend({}, $params, {week:$today.clone().format('DD-MM-YYYY')});
                        break;
                    }
                }
                //Scroll
                nurseslounge_myDashboard_schedule.get($params, function($data){
                    nurseslounge_myDashboard_schedule.createCalendar($selectedView, $today, $data);
                    var $calendarViewWeek = $(".calendar .view-week");
                    var $activeTimeLine = $calendarViewWeek.find(".week-timeline.active");
                    if($activeTimeLine.length > 0 && $calendarViewWeek.is(':visible')){
                        var $scrollPosition = $activeTimeLine.offset().top;
                        //$("html, body").animate({scrollTop:parseInt($scrollPosition) - 150});
                    }
                    var $calendarViewDay = $(".calendar .view-day");
                    var $activeTimeLine = $calendarViewDay.find(".week-timeline.active");
                    if($activeTimeLine.length > 0 && $calendarViewDay.is(':visible')){
                        var $scrollPosition = $activeTimeLine.offset().top;
                        //$("html, body").animate({scrollTop:parseInt($scrollPosition) - 150});
                    }
                    var $calendarViewList = $(".calendar .view-list");
                    var $activeTimeLine = $calendarViewList.find(".timeline.active");
                    if($activeTimeLine.length > 0 &&  $calendarViewList.is(':visible')){
                        var $scrollPosition = $activeTimeLine.offset().top;
                        //$("html, body").animate({scrollTop:parseInt($scrollPosition) - 150});
                    }
                });
            });
            $createEvent.unbind().click(function(){
                var $params = {user_id:$userId, area:$area};
                nurseslounge_myDashboard_schedule.getEventModal($params);
                //var $params = {user_id:$userId, area:$area};
                //nurseslounge_myDashboard_schedule.openPreviousEvent($params);
            });
            var $calendarViewWeek = $(".calendar .view-week");
            var $activeTimeLine = $calendarViewWeek.find(".week-timeline.active");
            if($activeTimeLine.length > 0 && $calendarViewWeek.is(':visible')){
                var $scrollPosition = $activeTimeLine.offset().top;
                //$("html, body").animate({scrollTop:parseInt($scrollPosition) - 150});
            }
            var $calendarViewDay = $(".calendar .view-day");
            var $activeTimeLine = $calendarViewDay.find(".week-timeline.active");
            if($activeTimeLine.length > 0 && $calendarViewDay.is(':visible')){
                var $scrollPosition = $activeTimeLine.offset().top;
                //$("html, body").animate({scrollTop:parseInt($scrollPosition) - 150});
            }
            var $calendarViewList = $(".calendar .view-list");
            var $activeTimeLine = $calendarViewList.find(".timeline.active");
            if($activeTimeLine.length > 0 &&  $calendarViewList.is(':visible')){
                var $scrollPosition = $activeTimeLine.offset().top;
                //$("html, body").animate({scrollTop:parseInt($scrollPosition) - 150});
            }
        });
    },
    //Save Events Init
    getEventModal:function($params){
        var $myCalendar = $("#nurseslounge-home-schedule");
        var $timeZone = $myCalendar.find(".time-zone");
        var $area = $timeZone.data('area');
        $params = $.extend({}, $params, {area:$area});
        var $modal = $("#home-my-profile-schedule-events");
        var $modalTitle = $modal.find(".modal-title");
        var $modalBody = $modal.find(".modal-body");
        nurseslounge_myDashboard_schedule.getEventRequest($params, function($chtml){
            var $modalFooter = $($chtml).find('.modal-footer:first');
            var $isOwner = $modalFooter.data('owner') == 1;
            var $key = $modalFooter.data('key');
            var $hasKey = $key  && $key != '';
            var $createEditHtml = '';
            if($hasKey){
                if(!$isOwner){
                    $createEditHtml = 'Invitation to an event';
                }else{
                    $createEditHtml = 'Edit event';
                }
            }else{
                if($isOwner) {
                    $createEditHtml = 'Create event';
                }
            }
            $modalTitle.html($createEditHtml);
            $modalBody.html($chtml).promise().done(function(){
                var $modalForm = $modal.find("form");
                var $typeContainer = $modal.find('.event_type_container');
                var $typeEventType = $typeContainer.find('select[name="typeEventType"]');
                var $oneTimeEventContainer = $modal.find('.event_oneTimeEvent_container');
                $oneTimeEventContainer.hide();
                var $periodicalEventContainer = $modal.find('.event_periodicalEvent_container');
                $periodicalEventContainer.hide();
                var $periodContainer = $modal.find('.event_period_container');
                $periodContainer.hide();
                var $weeklyContainer = $modal.find('.event_weekly_container');
                var $weeklyContainerSelection = $weeklyContainer.find('.event_weekly_container_selection');
                $weeklyContainerSelection.hide();
                $weeklyContainer.hide();
                var $monthlyContainer = $modal.find('.event_monthly_container');
                var $monthlyContainerSelection = $monthlyContainer.find('.event_monthly_container_selection');
                $monthlyContainerSelection.hide();
                $monthlyContainer.hide();
                var $hoursContainer = $modal.find('.event_hours_container');
                var $hoursContainerSelection = $hoursContainer.find('.event_hours_container_selection');
                $hoursContainerSelection.hide();
                $hoursContainer.hide();
                var $notifyContainer = $modal.find('.event_notify_container');
                var $notifyContainerSelection = $notifyContainer.find('.event_notify_container_selection');
                $notifyContainerSelection.hide();
                $notifyContainer.hide();
                var $inviteUsersContainer = $modal.find('.event_inviteUsers_container');
                $inviteUsersContainer.hide();
                var $settingsContainer = $modal.find('.event_settings_container');
                $settingsContainer.hide();
                var $modalFooter = $modal.find('.modal-footer');
                $modalFooter.hide();
                $typeEventType.unbind().change(function(){
                    var $that = $(this);
                    $oneTimeEventContainer.hide();
                    $periodicalEventContainer.hide();
                    $periodContainer.hide();
                    $weeklyContainer.hide();
                    $monthlyContainer.hide();
                    $hoursContainer.hide();
                    $hoursContainerSelection.hide();
                    $notifyContainer.hide();
                    $notifyContainerSelection.hide();
                    $inviteUsersContainer.hide();
                    $settingsContainer.hide();
                    $modalFooter.hide();
                    $modalForm.find('.invalid-feedback').hide();
                    $modalForm.find('.error').removeClass('error');
                    $modalForm.find('.is-invalid').removeClass('is-invalid');
                    switch($that.val()){
                        case 'one_time':{
                            nurseslounge_myDashboard_schedule.oneTimeEvents();
                            break;
                        }
                        case 'periodical':{
                            nurseslounge_myDashboard_schedule.periodicalEvents();
                            break;
                        }
                    }
                });
                var $modalDescription =$modalForm.find("textarea[name='dataDescription']");
                var $modalDescriptionCharacters =$modalForm.find("input[name='dataDescriptionCharacters']");
                $modalDescription.unbind().on('keyup keydown keypress', function(){
                    var $that = $(this);
                    var $val = $that.val();
                    var $allowedCharacters = 200 - $val.length;
                    $allowedCharacters = $allowedCharacters > 0 ? $allowedCharacters : 0;
                    if($allowedCharacters <= 0){
                        $that.val($val.substring(0, 200));
                    }
                    $modalDescriptionCharacters.val($allowedCharacters);
                });
                switch($typeEventType.val()){
                    case 'one_time':{
                        nurseslounge_myDashboard_schedule.oneTimeEvents();
                        break;
                    }
                    case 'periodical':{
                        nurseslounge_myDashboard_schedule.periodicalEvents();
                        break;
                    }
                }
                libs.checkImageLoad($($chtml).find('img'), function(){
                    $modal.modal('show');
                });
            });
        });
    },
    getEventRequest:function($params, cback){
        $.ajax({
            url: "/myDashboard/schedule/getEvent",
            method: 'POST',
            cache: false,
            dataType: "html",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    //
    oneTimeEvents:function(){
        var $userId = libs.memoryGet('user_id');
        var $modal = $("#home-my-profile-schedule-events");
        var $oneTimeEventContainer = $modal.find('.event_oneTimeEvent_container');
        var $oneTimeEventDay = $oneTimeEventContainer.find('.day');
        var $oneTimeEventResetDay = $oneTimeEventContainer.find('.reset_day');
        var $date = $oneTimeEventDay.data('value') != '' ? moment($oneTimeEventDay.data('value'), 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY') : moment().format('MM/DD/YYYY');
        $oneTimeEventDay.val($date).datepicker("update");
        $oneTimeEventDay.on('changeDate', function () {
            $(this).datepicker('hide');
        });
        $oneTimeEventResetDay.unbind().click(function(){
            $oneTimeEventDay.val($date).datepicker("update");
        });
        nurseslounge_myDashboard_schedule.mandatoryEvents();
        nurseslounge_myDashboard_schedule.oneTimeEventsValidator(function($form){
            var $params = libs.getObjForm($form);
            var $title = $params.dataTitle;
            var $description = $params.dataDescription;
            var $link = $params.dataLink;
            var $type = $params.typeEventType;
            var $permanent = 0;
            var $from = $params.oneTimeEventDay;
            var $to = $params.oneTimeEventDay;
            var $period = null;
            var $include = null;
            var $days = null;
            var $allTimeDay = $params.hourAllDayCheckbox == 'on' ? 1 : 0;
            var $startAt = $params.hourSelectionFromHour;
            var $endAt = $params.hourSelectionToHour;
            var $notificationBeforeEvent = $params.notifyBeforeEventCheckbox == 'on' ? 1 : 0;
            var $notificationTime = null;
            var $notifyNotificationUnitTime = null;
            var $inviteUsersCheckbox = $params.inviteUsersCheckbox == 'on' ? 1 : 0;
            var $inviteUsersList = $params.inviteUsersList ? JSON.parse($params.inviteUsersList) : [];
            var $invitations = [];
            var $color = libs.rgb2hex($("input[name='settingsColor']").css('backgroundColor'));
            var $available = $params.available == 'on' ? 1 : 0;
            if($notificationBeforeEvent == 1){
                $notificationTime = $params.notifyNotificationTimes;
                $notifyNotificationUnitTime = $params.notifyNotificationUnitTime;
            }
            if($inviteUsersCheckbox == 1){
                $.each($inviteUsersList, function($i, $v){
                    $invitations.push($v.id);
                });
            }
            var $myCalendar = $("#nurseslounge-home-schedule");
            var $timeZone = $myCalendar.find(".time-zone");
            var $area = $timeZone.data('area');
            var $event = {
                user_id:$userId,
                area:$area,
                title:$title,
                description:$description,
                link:$link,
                type:$type,
                permanent:$permanent,
                from:$from,
                to:$to,
                period:$period,
                include:$include,
                days:$days,
                all_time_day:$allTimeDay,
                start_at:$startAt,
                end_at:$endAt,
                notification_time:$notificationTime,
                notification_unit_time:$notifyNotificationUnitTime,
                color:$color,
                available:$available,
                invitations:$invitations.join(','),
                selected_date:nurseslounge_myDashboard_schedule.selectedDate.clone().format('DD-MM-YYYY')
            };
            nurseslounge_myDashboard_schedule.saveEvent($event);
        });
        nurseslounge_myDashboard_schedule.deleteEvent();
        $oneTimeEventContainer.show();
    },
    oneTimeEventsValidator:function(cback){
        $.validator.addMethod("dateGreaterThanHour", function($v, $ele, $params) {
            var $oneTimeEventDay = $("#home-my-profile-schedule-events form .event_oneTimeEvent_container input[name='oneTimeEventDay']").val();
            var $date = $oneTimeEventDay+' '+$v;
            return $params != false ? moment($date, 'MM/DD/YYYY h:mm A') > moment($params, 'MM/DD/YYYY h:mm A') : true;
        },'Date must be greater than {0}.');
        $.validator.addMethod("dateGreaterThanDay", function($v, $ele, $params) {
            return $params != false ? moment($v, 'MM/DD/YYYY') > $params : true;
        },'Date must be greater than {0}.');
        var $validator;
        try {
            $validator = $("#home-my-profile-schedule-events form").validate();
            $validator.destroy();
        }catch (e) {

        }
        var $typeEventType = $('#home-my-profile-schedule-events form .event_type_container select[name="typeEventType"]');
        var $hourAllDayCheckbox = $('#home-my-profile-schedule-events form .event_hours_container input[name="hourAllDayCheckbox"]');
        var $notifyBeforeEventCheckbox = $('#home-my-profile-schedule-events form .event_notify_container input[name="notifyBeforeEventCheckbox"]');
        var $inviteUsersCheckbox = $('#home-my-profile-schedule-events form .event_inviteUsers_container input[name="inviteUsersCheckbox"]');
        $validator = $("#home-my-profile-schedule-events form").validate({
            onsubmit: true,
            debug: true,
            ignore: "*:not(.validate)",
            rules: {
                dataTitle: {
                    required: true
                },
                dataDescription: {
                    required: true,
                    minlength: 1,
                    maxlength: 200
                },
                dataLink: {
                    required: false
                },
                typeEventType: {
                    required: true,
                },
                oneTimeEventDay: {
                    required: function () {
                        return $typeEventType.val() == 'one_time';
                    }
                },
                hourSelectionFromHour:{
                    required: function () {
                        return !$hourAllDayCheckbox.is(':checked');
                    }
                },
                hourSelectionToHour:{
                    required: function () {
                        return !$hourAllDayCheckbox.is(':checked');
                    },
                    dateGreaterThanHour:function(){
                        var $oneTimeEventDay = $("#home-my-profile-schedule-events form .event_oneTimeEvent_container input[name='oneTimeEventDay']").val();
                        var $hourSelectionFromHour = $("#home-my-profile-schedule-events form .event_hours_container input[name='hourSelectionFromHour']").val();
                        var $date = $oneTimeEventDay+' '+$hourSelectionFromHour;
                        return $typeEventType.val() == 'one_time' && !$hourAllDayCheckbox.is(':checked') ? moment($date, 'MM/DD/YYYY h:mm A') : false;
                    }
                },
                notifyNotificationTimes:{
                    required: function () {
                        return !$notifyBeforeEventCheckbox.is(':checked');
                    }
                },
                notifyNotificationUnitTime:{
                    required: function () {
                        return !$notifyBeforeEventCheckbox.is(':checked');
                    }
                },
                inviteUsersList:{
                    required: function () {
                        return $inviteUsersCheckbox.is(':checked');
                    }
                },
            },
            messages: {
                dataTitle: {
                    required: "The event title is required",
                },
                dataDescription: {
                    required: "The event description is required",
                    minlength: "The event description must have at least 1 characters",
                    maxlength: "The event description cannot exceed 200 characters"
                },
                dataLink: {
                    required: "The event link is not required",
                },
                typeEventType: {
                    required: "The event type is required"
                },
                oneTimeEventDay: {
                    required: "The event type day is required"
                },
                hourSelectionFromHour: {
                    required: "The event from hour is required"
                },
                hourSelectionToHour: {
                    required: "The event to hour is required",
                    dateGreaterThanHour:'The event to hour must be greater than from hour'
                },
                notifyNotificationTimes:{
                    required: "The time prev for notification is required"
                },
                notifyNotificationUnitTime: {
                    required: "The unit time prev for notification is required"
                },
                inviteUsersList: {
                    required: "The colleagues list is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    //
    periodicalEvents:function(){
        var $userId = libs.memoryGet('user_id');
        var $modal = $("#home-my-profile-schedule-events");
        var $periodicalEventContainer = $modal.find('.event_periodicalEvent_container');
        var $periodicalEventFromDate = $periodicalEventContainer.find('.from_date');
        var $periodicalEventFromResetDate = $periodicalEventContainer.find('.reset_from_date');
        var $periodicalEventToDate = $periodicalEventContainer.find('.to_date');
        var $periodicalEventToResetDate = $periodicalEventContainer.find('.reset_to_date');
        var $periodicalEventPermanentCheckbox = $periodicalEventContainer.find('input[name="periodicalEventPermanentCheckbox"]');
        var $periodicalEventContainerSelection = $periodicalEventContainer.find('.event_periodicalEvent_container_selection');
        var $periodContainer = $modal.find('.event_period_container');
        var $periodDate = $periodContainer.find('select[name="periodDate"]');
        var $weeklyContainer = $modal.find('.event_weekly_container');
        var $monthlyContainer = $modal.find('.event_monthly_container');
        $periodicalEventPermanentCheckbox.unbind().change(function(){
            var $that = $(this);
            if($that.is(':checked')){
                $periodicalEventContainerSelection.hide();
            }else{
                $periodicalEventContainerSelection.show();
            }
        });
        if($periodicalEventPermanentCheckbox.is(':checked')){
            $periodicalEventContainerSelection.hide();
        }else{
            $periodicalEventContainerSelection.show();
        }
        var $fromDate = $periodicalEventFromDate.data('value') != '' ? moment($periodicalEventFromDate.data('value'), 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY') : moment().format('MM/DD/YYYY');
        $periodicalEventFromDate.val($fromDate).datepicker("update");
        $periodicalEventFromDate.on('changeDate', function () {
            $(this).datepicker('hide');
        });
        $periodicalEventFromResetDate.unbind().click(function(){
            $periodicalEventFromDate.val($fromDate).datepicker("update");
        });
        var $toDate = $periodicalEventToDate.data('value') != '' ? moment($periodicalEventToDate.data('value'), 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY') : moment().format('MM/DD/YYYY');
        $periodicalEventToDate.val($toDate).datepicker("update");
        $periodicalEventToDate.on('changeDate', function () {
            $(this).datepicker('hide');
        });
        $periodicalEventToResetDate.unbind().click(function(){
            $periodicalEventToDate.val($toDate).datepicker("update");
        });

        $periodDate.unbind().change(function(){
            var $that = $(this);
            $weeklyContainer.hide();
            $monthlyContainer.hide();
            switch($that.val()){
                case 'all':{
                    $weeklyContainer.hide();
                    $monthlyContainer.hide();
                    break;
                }
                case 'monthly':{
                    nurseslounge_myDashboard_schedule.monthlyEvents();
                    break;
                }
                case 'weekly':{
                    nurseslounge_myDashboard_schedule.weeklyEvents();
                    break;
                }
            }
        });
        switch($periodDate.val()){
            case 'all':{
                $weeklyContainer.hide();
                $monthlyContainer.hide();
                break;
            }
            case 'monthly':{
                nurseslounge_myDashboard_schedule.monthlyEvents();
                break;
            }
            case 'weekly':{
                nurseslounge_myDashboard_schedule.weeklyEvents();
                break;
            }
        }
        nurseslounge_myDashboard_schedule.mandatoryEvents();
        nurseslounge_myDashboard_schedule.periodicalEventsValidator(function($form){
            var $params = libs.getObjForm($form);
            var $title = $params.dataTitle;
            var $description = $params.dataDescription;
            var $link = $params.dataLink;
            var $type = $params.typeEventType;
            var $permanent = $params.periodicalEventPermanentCheckbox == 'on' ? 1 : 0;
            var $from = $params.periodicalEventFromDate;
            var $to = $params.periodicalEventToDate;
            var $period = $params.periodDate;
            var $include = null;
            var $days = null;
            var $allTimeDay = $params.hourAllDayCheckbox == 'on' ? 1 : 0;
            var $startAt = $params.hourSelectionFromHour;
            var $endAt = $params.hourSelectionToHour;
            var $notificationBeforeEvent = $params.notifyBeforeEventCheckbox == 'on' ? 1 : 0;
            var $notificationTime = null;
            var $notifyNotificationUnitTime = null;
            var $inviteUsersCheckbox = $params.inviteUsersCheckbox == 'on' ? 1 : 0;
            var $inviteUsersList = $params.inviteUsersList ? JSON.parse($params.inviteUsersList) : [];
            var $invitations = [];
            var $color = libs.rgb2hex($("input[name='settingsColor']").css('backgroundColor'));
            var $available = $params.available == 'on' ? 1 : 0;
            switch($period){
                case 'weekly':{
                        var $weeklyDate = $params.weeklyDate;
                        $days = $params.weeklyDatesSelected;
                        switch($weeklyDate){
                            case 'weekly_every':{
                                $include = 'every';
                                break;
                            }
                            case 'weekly_except':{
                                $include = 'except';
                                break;
                            }
                        }
                    break;
                }
                case 'monthly':{
                    var $monthlyDate = $params.monthlyDate;
                    $days = $params.monthlyDatesSelected;
                    switch($monthlyDate){
                        case 'monthly_every':{
                            $include = 'every';
                            break;
                        }
                        case 'monthly_except':{
                            $include = 'except';
                            break;
                        }
                    }
                    break;
                }
            }
            if($notificationBeforeEvent == 1){
                $notificationTime = $params.notifyNotificationTimes;
                $notifyNotificationUnitTime = $params.notifyNotificationUnitTime;
            }
            if($inviteUsersCheckbox == 1){
                $.each($inviteUsersList, function($i, $v){
                    $invitations.push($v.id);
                });
            }
            var $myCalendar = $("#nurseslounge-home-schedule");
            var $timeZone = $myCalendar.find(".time-zone");
            var $area = $timeZone.data('area');
            var $event = {
                user_id:$userId,
                area:$area,
                title:$title,
                description:$description,
                link:$link,
                type:$type,
                permanent:$permanent,
                from:$from,
                to:$to,
                period:$period,
                include:$include,
                days:$days,
                all_time_day:$allTimeDay,
                start_at:$startAt,
                end_at:$endAt,
                notification_time:$notificationTime,
                notification_unit_time:$notifyNotificationUnitTime,
                color:$color,
                available:$available,
                invitations:$invitations.join(','),
                selected_date:nurseslounge_myDashboard_schedule.selectedDate.clone().format('DD-MM-YYYY')
            };
            nurseslounge_myDashboard_schedule.saveEvent($event);
        });
        nurseslounge_myDashboard_schedule.deleteEvent();
        $periodicalEventContainer.show();
        $periodContainer.show();
    },
    periodicalEventsValidator:function(cback){
        $.validator.addMethod("dateGreaterThanHourStart", function($v, $ele, $params) {
            var $periodicalEventFromDate = $("#home-my-profile-schedule-events form .event_periodicalEvent_container input[name='periodicalEventFromDate']").val();
            var $date = $periodicalEventFromDate+' '+$v;
            return $params != false ? moment($date, 'MM/DD/YYYY h:mm A') > moment($params, 'MM/DD/YYYY h:mm A') : true;
        },'Date must be greater than {0}.');
        $.validator.addMethod("dateGreaterThanHourEnd", function($v, $ele, $params) {
            var $periodicalEventPermanentCheckbox = $('#home-my-profile-schedule-events form .event_periodicalEvent_container input[name="periodicalEventPermanentCheckbox"]');
            var $date;
            if($periodicalEventPermanentCheckbox.is(':checked')){
                var $periodicalEventFromDate = $("#home-my-profile-schedule-events form .event_periodicalEvent_container input[name='periodicalEventFromDate']").val();
                $date = $periodicalEventFromDate+' '+$v;
            }else{
                var $periodicalEventToDate = $("#home-my-profile-schedule-events form .event_periodicalEvent_container input[name='periodicalEventToDate']").val();
                $date = $periodicalEventToDate+' '+$v;
            }
            return $params != false ? moment($date, 'MM/DD/YYYY h:mm A') > moment($params, 'MM/DD/YYYY h:mm A') : true;
        },'Date must be greater than {0}.');
        $.validator.addMethod("dateGreaterThanDay", function($v, $ele, $params) {
            return $params;
        },'Date must be greater than {0}.');
        /*
        $.validator.addMethod("maxFourteen", function($v, $ele, $params) {
            var $start = $params;
            var $end = moment($v, 'MM/DD/YYYY');
            var $duration = moment.duration($end.diff($start));
            var $days = $duration.asDays();
            return $days <= 14 ? true : false;
        },'Date must be greater than {0}.');
         */
        var $validator;
        try {
            $validator = $("#home-my-profile-schedule-events form").validate();
            $validator.destroy();
        }catch (e) {

        }
        var $typeEventType = $('#home-my-profile-schedule-events form .event_type_container select[name="typeEventType"]');
        var $hourAllDayCheckbox = $('#home-my-profile-schedule-events form .event_hours_container input[name="hourAllDayCheckbox"]');
        var $notifyBeforeEventCheckbox = $('#home-my-profile-schedule-events form .event_notify_container input[name="notifyBeforeEventCheckbox"]');
        var $inviteUsersCheckbox = $('#home-my-profile-schedule-events form .event_inviteUsers_container input[name="inviteUsersCheckbox"]');
        var $periodicalEventFromDate = $('#home-my-profile-schedule-events form .event_periodicalEvent_container input[name="periodicalEventFromDate"]');
        var $periodicalEventToDate = $('#home-my-profile-schedule-events form .event_periodicalEvent_container input[name="periodicalEventToDate"]');
        var $periodicalEventPermanentCheckbox = $('#home-my-profile-schedule-events form .event_periodicalEvent_container input[name="periodicalEventPermanentCheckbox"]');
        var $periodDate = $('#home-my-profile-schedule-events form .event_period_container select[name="periodDate"]');
        var $monthlyDatesSelectedArr = [];
        var $weeklyDatesSelectedArr = [];
        $validator = $("#home-my-profile-schedule-events form").validate({
            onsubmit: true,
            debug: true,
            ignore: "*:not(.validate)",
            rules: {
                dataTitle: {
                    required: true
                },
                dataDescription: {
                    required: false,
                    minlength: 1,
                    maxlength: 200
                },
                dataLink: {
                    required: false
                },
                typeEventType: {
                    required: true,
                },
                periodicalEventFromDate: {
                    required: function () {
                        return $typeEventType.val() == 'periodical';
                    }
                },
                periodicalEventToDate: {
                    required: function () {
                        return $typeEventType.val() == 'periodical';
                    },
                    dateGreaterThanDay:function () {
                        var $nowDay = $periodicalEventFromDate.val();
                        $nowDay = moment($nowDay, 'MM/DD/YYYY');
                        $nowDay = $nowDay.subtract(1, 'day');
                        var $toDate = $periodicalEventToDate.val();
                        setTimeout(function(){
                            var $newToDate = $periodicalEventToDate.val();
                            if($toDate != $newToDate && !$periodicalEventPermanentCheckbox.is(':checked')){
                                $periodicalEventToDate.blur();
                            }
                        },800);
                        var $toDateMoment = moment($toDate, 'MM/DD/YYYY');
                        return !$periodicalEventPermanentCheckbox.is(':checked') ? $toDateMoment > $nowDay : false;
                    },
                    /*maxFourteen:function () {
                        var $nowDay = $periodicalEventFromDate.val();
                        $nowDay = moment($nowDay, 'MM/DD/YYYY');
                        return moment($nowDay, 'MM/DD/YYYY');
                    }*/
                },
                monthlyDatesSelected:{
                    required: function () {
                        var $monthlyDatesSelected = $('#home-my-profile-schedule-events form .event_monthly_container input[name="monthlyDatesSelected"]');
                        var $monthlyDate = $('#home-my-profile-schedule-events form .event_monthly_container select[name="monthlyDate"]');
                        $monthlyDatesSelectedArr.length = 0;
                        var $tableDatesSelected = $('#home-my-profile-schedule-events form .event_monthly_container_selection_table tr td .dates');
                        $tableDatesSelected.each(function($i, $v){
                            $monthlyDatesSelectedArr.push($(this).data('date'));
                        });
                        $monthlyDatesSelected.val($monthlyDatesSelectedArr.join(','));
                        return $periodDate.val() == 'monthly' && $monthlyDate.val() != 'monthly_every_day';
                    },
                },
                weeklyDatesSelected:{
                    required: function () {
                        var $weeklyDatesSelected = $('#home-my-profile-schedule-events form .event_weekly_container input[name="weeklyDatesSelected"]');
                        var $weeklyDate = $('#home-my-profile-schedule-events form .event_weekly_container select[name="weeklyDate"]');
                        $weeklyDatesSelectedArr.length = 0;
                        var $tableDatesSelected = $('#home-my-profile-schedule-events form .event_weekly_container_selection .weekly_days');
                        $tableDatesSelected.each(function($i, $v){
                            var $that = $(this);
                            if($that.is(':checked') == true){
                                $weeklyDatesSelectedArr.push($that.data('value'));
                            }
                        });
                        $weeklyDatesSelected.val($weeklyDatesSelectedArr.join(','));
                        return $periodDate.val() == 'weekly' && $weeklyDate.val() != 'weekly_every_day';
                    },
                },
                hourSelectionFromHour:{
                    required: function () {
                        return !$hourAllDayCheckbox.is(':checked');
                    }
                },
                hourSelectionToHour:{
                    required: function () {
                        return !$hourAllDayCheckbox.is(':checked');
                    },
                    dateGreaterThanHourEnd:function(){
                        var $periodicalEventFromDate = $("#home-my-profile-schedule-events form .event_periodicalEvent_container input[name='periodicalEventFromDate']").val();
                        var $hourSelectionFromHour = $("#home-my-profile-schedule-events form .event_hours_container input[name='hourSelectionFromHour']").val();
                        var $date = $periodicalEventFromDate+' '+$hourSelectionFromHour;
                        return $typeEventType.val() == 'periodical' && !$hourAllDayCheckbox.is(':checked') ? moment($date, 'MM/DD/YYYY h:mm A') : false;
                    }
                },
                notifyNotificationTimes:{
                    required: function () {
                        return !$notifyBeforeEventCheckbox.is(':checked');
                    }
                },
                notifyNotificationUnitTime:{
                    required: function () {
                        return !$notifyBeforeEventCheckbox.is(':checked');
                    }
                },
                inviteUsersList:{
                    required: function () {
                        return $inviteUsersCheckbox.is(':checked');
                    }
                },
            },
            messages: {
                dataTitle: {
                    required: "The event title is required",
                },
                dataDescription: {
                    required: "The event description is required",
                    minlength: "The event description must have at least 1 characters",
                    maxlength: "The event description cannot exceed 200 characters"
                },
                dataLink: {
                    required: "The event link is not required",
                },
                typeEventType: {
                    required: "The event type is required"
                },
                periodicalEventFromDate: {
                    required: "The event from date is required"
                },
                periodicalEventToDate: {
                    required: "The event to date is required",
                    dateGreaterThanDay:"The event to date must be greater than from date",
                    //maxFourteen:"The maximum event length allowed is 14 days.",
                },
                monthlyDatesSelected:{
                    required: "The event must have at least one day selected of the month",
                },
                weeklyDatesSelected:{
                    required: "The event must have at least one day selected of the week",
                },
                hourSelectionFromHour: {
                    required: "The event from hour is required",
                },
                hourSelectionToHour: {
                    required: "The event to hour is required",
                    dateGreaterThanHourEnd:'The event to hour must be greater than from hour'
                },
                notifyNotificationTimes:{
                    required: "The time prev for notification is required"
                },
                notifyNotificationUnitTime: {
                    required: "The unit time prev for notification is required"
                },
                inviteUsersList: {
                    required: "The colleagues list is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    monthlyEvents:function(){
        var $modal = $("#home-my-profile-schedule-events");
        var $monthlyContainer = $modal.find('.event_monthly_container');
        var $add = $monthlyContainer.find('.add');
        var $monthlyDate = $monthlyContainer.find('select[name="monthlyDate"]');
        var $monthlyDates = $monthlyContainer.find('select[name="monthlyDates"]');
        var $monthlyDatesSelected = $monthlyContainer.find('input[name="monthlyDatesSelected"]');
        var $monthlyContainerSelection = $monthlyContainer.find('.event_monthly_container_selection');
        var $monthlyContainerSelectionTable = $monthlyContainer.find('.event_monthly_container_selection_table');
        var $firstTr = $monthlyContainerSelectionTable.children().first();
        var $everyTxt = '<td>Every day(s)</td><td>Delete</td>';
        var $exceptTxt = '<td>Except day(s)</td><td>Delete</td>';
        $add.unbind().click(function(){
            var $monthlyDatesVal = $monthlyDates.val();
            var $chtml = '';
            $chtml += '' +
                '<tr>' +
                '    <td><span class="dates" data-date="'+$monthlyDatesVal+'">'+$monthlyDatesVal+'</span></td>' +
                '    <td>' +
                '        <button type="button" class="btn btn-danger" onclick="$(this).parents(\'tr:first\').remove();">' +
                '            <i class="fa fa-ban"></i>' +
                '        </button>' +
                '    </td>' +
                '</tr>';
                $monthlyContainerSelectionTable.children().first().after($chtml);
        });
        $monthlyDatesSelected = $monthlyDatesSelected.val() != '' ? $monthlyDatesSelected.val().split(',') : null;
        if($monthlyDatesSelected){
            $.each($monthlyDatesSelected, function($i, $v){
                var $chtml = '';
                $chtml += '' +
                    '<tr>' +
                    '    <td><span class="dates" data-date="'+$v+'">'+$v+'</span></td>' +
                    '    <td>' +
                    '        <button type="button" class="btn btn-danger" onclick="$(this).parents(\'tr:first\').remove();">' +
                    '            <i class="fa fa-ban"></i>' +
                    '        </button>' +
                    '    </td>' +
                    '</tr>';
                $monthlyContainerSelectionTable.children().first().after($chtml);
            });
        }
        $monthlyDate.unbind().change(function(){
            var $that = $(this);
            $monthlyContainerSelection.hide();
            if($that.val() == 'monthly_every_day'){
                $monthlyContainerSelectionTable.html($monthlyContainerSelectionTable.children().first());
                $monthlyContainerSelection.hide();
            }else{
                if($that.val() == 'monthly_every') {
                    $firstTr.html($everyTxt);
                }else{
                    $firstTr.html($exceptTxt);
                }
                $monthlyContainerSelection.show();
            }
        });
        if($monthlyDate.val() == 'monthly_every_day'){
            $monthlyContainerSelectionTable.html($monthlyContainerSelectionTable.children().first());
            $monthlyContainerSelection.hide();
        }else{
            if($monthlyDate.val() == 'monthly_every') {
                $firstTr.html($everyTxt);
            }else{
                $firstTr.html($exceptTxt);
            }
            $monthlyContainerSelection.show();
        }
        $monthlyContainer.show();
    },
    weeklyEvents:function(){
        var $modal = $("#home-my-profile-schedule-events");
        var $weeklyContainer = $modal.find('.event_weekly_container');
        var $weeklyDate = $modal.find('select[name="weeklyDate"]');
        var $weeklyDays = $modal.find('.weekly_days');
        var $weeklyContainerSelection = $weeklyContainer.find('.event_weekly_container_selection');
        $weeklyDate.unbind().change(function(){
            var $that = $(this);
            if($that.val() == 'weekly_every_day'){
                $weeklyDays.prop('checked', false);
                $weeklyContainerSelection.hide();
            }else{
                $weeklyContainerSelection.show();
            }
        });
        if($weeklyDate.val() == 'weekly_every_day'){
            $weeklyDays.prop('checked', false);
            $weeklyContainerSelection.hide();
        }else{
            $weeklyContainerSelection.show();
        }
        $weeklyContainer.show();
    },
    //
    mandatoryEvents:function(){
        var $now = moment();
        var $modal = $("#home-my-profile-schedule-events");
        var $hoursContainer = $modal.find('.event_hours_container');
        var $hoursContainerSelection = $hoursContainer.find('.event_hours_container_selection');
        var $hourAllDayCheckbox = $modal.find('input[name="hourAllDayCheckbox"]');
        var $hoursContainerFromHour = $("#schedule_event_hours_container_selection_from_hour");
        var $hoursContainerToHour = $("#schedule_event_hours_container_selection_to_hour");
        var $notifyContainer = $modal.find('.event_notify_container');
        var $notifyContainerSelection = $notifyContainer.find('.event_notify_container_selection');
        var $notifyBeforeEventCheckbox = $notifyContainer.find('input[name="notifyBeforeEventCheckbox"]');
        var $inviteUsersContainer = $modal.find('.event_inviteUsers_container');
        var $inviteUsersContainerSelection = $inviteUsersContainer.find('.event_inviteUsers_container_selection');
        var $inviteUsersCheckbox = $inviteUsersContainer.find('input[name="inviteUsersCheckbox"]');
        var $inviteUsersList = $inviteUsersContainer.find('input[name="inviteUsersList"]');
        var $settingsContainer = $modal.find('.event_settings_container');
        var $settingsColor = $settingsContainer.find('input[name="settingsColor"]');
        var $modalFooter = $modal.find('.modal-footer');
        $hourAllDayCheckbox.unbind().change(function(){
            var $that = $(this);
            if($that.is(':checked')){
                $hoursContainerSelection.hide();
            }else{
                var $fromHour = $hoursContainerFromHour.data('value') != '' ? moment($hoursContainerFromHour.data('value'), 'YYYY-MM-DD HH:mm:ss') : $now.clone();
                $hoursContainerFromHour.datetimepicker({
                    defaultDate: $fromHour,
                    format: 'LT'
                });
                var $toHour = $hoursContainerFromHour.data('value') != '' ? moment($hoursContainerToHour.data('value'), 'YYYY-MM-DD HH:mm:ss') : $now.clone().add(1,'hour');
                $hoursContainerToHour.datetimepicker({
                    defaultDate: $toHour,
                    format: 'LT',
                });
                $hoursContainerSelection.show();
            }
        });
        if($hourAllDayCheckbox.is(':checked')){
            $hoursContainerSelection.hide();
        }else{
            var $fromHour = $hoursContainerFromHour.data('value') != '' ? moment($hoursContainerFromHour.data('value'), 'YYYY-MM-DD HH:mm:ss') : $now.clone();
            $hoursContainerFromHour.datetimepicker({
                defaultDate: $fromHour,
                format: 'LT',
            });
            var $toHour = $hoursContainerFromHour.data('value') != '' ? moment($hoursContainerToHour.data('value'), 'YYYY-MM-DD HH:mm:ss') : $now.clone().add(1,'hour');
            $hoursContainerToHour.datetimepicker({
                defaultDate: $toHour,
                format: 'LT',
            });
            $hoursContainerSelection.show();
        }

        $notifyBeforeEventCheckbox.unbind().change(function(){
            var $that = $(this);
            if($that.is(':checked')){
                $notifyContainerSelection.show();
            }else{
                $notifyContainerSelection.hide();
            }
        });
        if($notifyBeforeEventCheckbox.is(':checked')){
            $notifyContainerSelection.show();
        }else{
            $notifyContainerSelection.hide();
        }

        $inviteUsersCheckbox.unbind().change(function(){
            var $that = $(this);
            if($that.is(':checked')){
                $inviteUsersContainerSelection.show();
            }else{
                $inviteUsersContainerSelection.hide();
            }
        });
        if($inviteUsersCheckbox.is(':checked')){
            $inviteUsersContainerSelection.show();
        }else{
            $inviteUsersContainerSelection.hide();
        }
        nurseslounge_myDashboard_schedule.colleaguesListAutocomplete($inviteUsersList);

        $settingsColor.paletteColorPicker({
            colors: [
                "#00FF00",
                "#B03060",
                "#A020F0",
                "#C0C0C0",
                "#00FF00",
                "#FF00FF",
                "#00FFFF",
                "#808080",
                "#008000",
                "#7F0000",
                "#7F007F",
            ],
            set_background: true,
            position: 'downside'
        });

        if($settingsColor.val() != ''){
            var $settingsColorBackground = $settingsContainer.find('div[data-target="settingsColor"]');
            $settingsColorBackground.css('backgroundColor', $settingsColor.val());
        }

        $hoursContainer.show();
        $notifyContainer.show();
        $inviteUsersContainer.show();
        $settingsContainer.show();
        $modalFooter.show();
    },
    colleaguesListAutocomplete:function($element){
        if($element.length == 0){
            return false;
        }
        var $autocompleteBinding;
        var $addAllSuggestionsElm;
        try{
            var $colleaguesListAutocomplete = libs.memoryGet('myDashboard_schedule_colleagues_list_autocomplete');
            $colleaguesListAutocomplete.destroy();
        }catch (e) {

        }
        var $tagify = new Tagify($element[0], {
            tagTextProp: 'name',
            enforceWhitelist: true,
            skipInvalid: true,
            dropdown: {
                closeOnSelect: false,
                enabled: 0,
                classname: 'users-list',
                searchKeys: ['long_name', 'email']
            },
            whitelist: [],
            templates: {
                tag: function($tagData){
                    return "<tag title='"+$tagData.email+"'" +
                        " contenteditable='false'" +
                        " spellcheck='false'" +
                        " tabIndex='-1' " +
                        " class='tagify__tag' "+$tagData.class ? $tagData.class : "" +
                        " " + this.getAttributes($tagData) + ">" +
                        "<x title='' class='tagify__tag__removeBtn' role='button' aria-label='remove tag'></x>" +
                        "   <div>" +
                        "       <div class='tagify__tag__avatar-wrap'>" +
                        "           <img onerror=\"this.style.visibility='hidden'\" src='"+$tagData.profile_image_root_friend+"'>" +
                        "       </div>" +
                        "       <span class='tagify__tag-text'>"+$tagData.long_name+"</span>" +
                        "   </div>" +
                        "</tag>";
                },
                dropdownItem: function($tagData){
                    return "<div "+this.getAttributes($tagData)+
                    " class='tagify__dropdown__item "+$tagData.class ? $tagData.class : "" +
                    " tabindex='0'" +
                    " role='option'>" +
                    $tagData.profile_image_root_friend ?
                        "<div class='tagify__dropdown__item__avatar-wrap'>" +
                        "   <img onerror=\"this.style.visibility='hidden'\" src='"+$tagData.profile_image_root_friend+"></div>"
                        :
                        "" +
                        "<strong>"+$tagData.long_name+"</strong>" +
                        "<span>"+$tagData.email+" - "+$tagData.profile.profile+"</span>" +
                        "</div>";
                }
            },
        }).on('dropdown:select', function($e){
            if($e.detail.elm == $addAllSuggestionsElm )
                $tagify.dropdown.selectAll.call($tagify);
        }).on('input', function($e){
            try{
                clearTimeout($autocompleteBinding);
            }catch ($e) {

            }
            $autocompleteBinding = setTimeout(function(){
                $tagify.loading(true).dropdown.hide.call($tagify);
                nurseslounge_myDashboard_schedule.searchColleaguesAutocompleteRequest($e.detail.value, function($data){
                    $tagify.settings.whitelist.length = 0;
                    $.each($data.data.users, function($i, $v){
                        $tagify.settings.whitelist.push($v);
                    });
                    $tagify.loading(false).dropdown.show.call($tagify, $e.detail.value);
                });
            }, 800);
        });
        if($element.data('value') != ''){
            var $users = JSON.parse($element.data('value'));
            $.each($users, function($i, $v){
                $tagify.settings.whitelist.push($v);
            });
            $tagify.addTags($users);
        }
        libs.memorySave('myDashboard_schedule_colleagues_list_autocomplete', $tagify);
    },
    searchColleaguesAutocompleteRequest:function($search, cback){
        var $userId = libs.memoryGet('user_id');
        var $params = $.extend({}, $params, {user_id:$userId, search:$search});
        $.ajax({
            url: "/myDashboard/myCalendar/colleagues/autocomplete",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    //Save Events
    deleteEvent:function(){
        var $userId = libs.memoryGet('user_id');
        var $modal = $("#home-my-profile-schedule-events");
        var $modalFooter = $modal.find('.modal-footer:first');
        var $submit = $modalFooter.find("button[type='submit']");
        var $deleteEvent = $modalFooter.find(".delete-event");
        var $waitMessage = $modalFooter.find(".wait-message");
        var $key = $modalFooter.data('key');
        var $hasKey = $key  && $key != '';
        var $title = $modal.find('input[name="dataTitle"]').val();
        var $myCalendar = $("#nurseslounge-home-schedule");
        var $timeZone = $myCalendar.find(".time-zone");
        var $area = $timeZone.data('area');
        var $params = $.extend({}, {user_id:$userId, key:$key, area:$area});
        $modal.find('.delete-event').unbind().click(function(){
            var $result = window.confirm('Do you want to delete the event "'+$title+'"?');
            if($hasKey && $result){
                $submit.hide();
                $deleteEvent.hide();
                $waitMessage.show();
                nurseslounge_myDashboard_schedule.deleteEventRequest($params, function($data){
                    var $selectedView = nurseslounge_myDashboard_schedule.selectedView;
                    var $params = {user_id:$userId, area:$area};
                    var $selectedDate = nurseslounge_myDashboard_schedule.selectedDate;
                    switch ($selectedView) {
                        case 'month':{
                            $params = $.extend({}, $params, {month:$selectedDate.clone().format('DD-MM-YYYY')});
                            break;
                        }
                        case 'week':{
                            $params = $.extend({}, $params, {week:$selectedDate.clone().format('DD-MM-YYYY')});
                            break;
                        }
                        case 'day':{
                            $params = $.extend({}, $params, {week:$selectedDate.clone().format('DD-MM-YYYY')});
                            break;
                        }
                        case 'list':{
                            $params = $.extend({}, $params, {week:$selectedDate.clone().format('DD-MM-YYYY')});
                            break;
                        }
                    }
                    $modal.modal('hide');
                    nurseslounge_myDashboard_schedule.get($params, function($data){
                        nurseslounge_myDashboard_schedule.createCalendar($selectedView, $selectedDate, $data);
                    });
                });
            }
        });
    },
    deleteEventRequest:function($params, cback){
        $.ajax({
            url: "/myDashboard/schedule/deleteEvent",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    saveEvent:function($event){
        var $userId = libs.memoryGet('user_id');
        var $modal = $("#home-my-profile-schedule-events");
        var $modalFooter = $modal.find('.modal-footer:first');
        var $submit = $modalFooter.find("button[type='submit']");
        var $deleteEvent = $modalFooter.find(".delete-event");
        var $waitMessage = $modalFooter.find(".wait-message");
        var $key = $modalFooter.data('key');
        var $hasKey = $key  && $key != '';
        var $myCalendar = $("#nurseslounge-home-schedule");
        var $timeZone = $myCalendar.find(".time-zone");
        var $area = $timeZone.data('area');
        $key = $hasKey ? $key : '';
        var $params = $.extend({}, {user_id:$userId, key:$key, area:$area}, $event);
        $submit.hide();
        $deleteEvent.hide();
        $waitMessage.show();
        nurseslounge_myDashboard_schedule.saveEventRequest($params, function($data){
            var $selectedDate = moment($data.data.selected_date, 'DD-MM-YYYY');
            var $selectedView = nurseslounge_myDashboard_schedule.selectedView;
            switch ($selectedView) {
                case 'month':{
                    $params = $.extend({}, $params, {month:$selectedDate.clone().format('DD-MM-YYYY')});
                    break;
                }
                case 'week':{
                    $params = $.extend({}, $params, {week:$selectedDate.clone().format('DD-MM-YYYY')});
                    break;
                }
                case 'day':{
                    $params = $.extend({}, $params, {week:$selectedDate.clone().format('DD-MM-YYYY')});
                    break;
                }
                case 'list':{
                    $params = $.extend({}, $params, {week:$selectedDate.clone().format('DD-MM-YYYY')});
                    break;
                }
            }
            nurseslounge_myDashboard_schedule.get($params, function($data){
                nurseslounge_myDashboard_schedule.createCalendar($selectedView, $selectedDate, $data);
            });
            $modal.modal('hide');
        });
    },
    saveEventRequest:function($params, cback){
        $.ajax({
            url: "/myDashboard/schedule/setEvent",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    //Calendar views
    getWeeks:function($momentDate, $data){
        var $weeks = [];
        var $firstWeekOfTheMonth = $momentDate.clone().startOf('month').week();
        $firstWeekOfTheMonth = parseInt($firstWeekOfTheMonth);
        var $lastWeekOfTheMonth = $momentDate.clone().endOf('month').week();
        $lastWeekOfTheMonth = parseInt($lastWeekOfTheMonth);
        var $lessYear = 0;
        var $weeksInYear = $momentDate.clone().weeksInYear();
        $weeksInYear = parseInt($weeksInYear);
        if($firstWeekOfTheMonth > $lastWeekOfTheMonth){
            $lastWeekOfTheMonth = $weeksInYear;
            $lastWeekOfTheMonth = $lastWeekOfTheMonth+1;
            $lessYear = 1;
        }
        for(var $w = $firstWeekOfTheMonth; $w<=($lastWeekOfTheMonth) ; $w++){
            var $startOfWeek = $momentDate.clone().week($w).startOf('week');
            var $days = [];
            for(var $d=0;$d<7;$d++){
                var $date = $startOfWeek.clone().subtract($lessYear, 'year').add($d, 'day');
                var $day = $date.format('DD');
                $day = libs.pad('00',$day,'l');
                var $properties = $data && $data.data && $data.data.weeks && $data.data.weeks[$w] && $data.data.weeks[$w][$day] ?
                    $data.data.weeks[$w][$day] : [];
                $days.push([$day, $properties, $date]);
            }
            $weeks.push([$w, $days]);
        }
        return $weeks;
    },
    createCalendarMonth:function($momentDate, $data) {
        var $userId = libs.memoryGet('user_id');
        var $weeks = nurseslounge_myDashboard_schedule.getWeeks($momentDate, $data);
        var $month = $momentDate.clone().format('MM');
        var $myCalendar = $("#nurseslounge-home-schedule");
        var $viewMonth = $myCalendar.find(".view-month");
        var $viewWeek = $myCalendar.find(".view-week");
        $viewWeek.hide();
        var $viewDay = $myCalendar.find(".view-day");
        $viewDay.hide();
        var $viewList = $myCalendar.find(".view-list");
        $viewList.hide();
        var $viewMonthThead = $viewMonth.find('.view-month-thead');
        var $viewMonthTbody = $viewMonth.find('.view-month-tbody');
        var $viewMonthTfoot = $viewMonth.find('.view-month-tfoot');
        var $weeksDaysMin = moment.weekdaysMin();
        var $chtml = '';
        $chtml += '<tr>';
            $.each($weeksDaysMin, function($i, $v){
                $chtml += '<th class="border">'+$v+'</th>';
        });
        $chtml += '</tr>';
        $viewMonthThead.html($chtml);
        $chtml = '';
        var $titleContent = [];
        var $titleEventContent = [];
        $.each($weeks, function($i, $v){
            var $w = $v[0] + 1;
            var $week = $v[1];
            $chtml += '' +
                '<tr>';
            $.each($week, function($i, $v) {
                var $day = $v[0];
                var $properties = $v[1];
                var $date = $v[2];
                var $bgSecondary = $date.format('MM') == $month ? '' : 'bg-secondary';
                var $textLight = $date.format('MM') == $month ? '' : 'text-light';
                var $isToday = $date.format('MM-DD') == moment().format('MM-DD') ? 'month-today': '';
                $chtml += '' +
                    '<td ' +
                    ' class="border '+$bgSecondary+' '+$isToday+'"' +
                    ' data-date="'+$date.format('YYYY-MM-DD HH:mm:ss')+'"' +
                    '>' +
                    '   <span class="month-tag '+$textLight+'">'+$day+'</span>' +
                    '       <div class="month-block">';
                    if($properties.eventsCount > 0){

                        var $toolTipHtml = '' +
                            '   <thead class="thead-dark">' +
                            '       <tr>' +
                            '           <th>Event</th>' +
                            '           <th>Title</th>' +
                            '           <th>Start At</th>' +
                            '           <th>End At</th>' +
                            '       </tr>';
                            '   </thead>';
                            $.each($properties.events, function($i, $v){
                                var $title = $v.title.length <= 15 ? $v.title : $v.title.substring(0, 15) + '...';
                                var $startAt = moment($v.start_at, 'YYYY-MM-DD HH:mm:ss').format('h:mm A');
                                var $endAt = moment($v.end_at, 'YYYY-MM-DD HH:mm:ss').format('h:mm A');
                                if($v.period == 'consecutive' && $v.periodRanges.length > 0){
                                    $startAt = $v.periodRanges[$w][$day] ? moment($v.periodRanges[$w][$day].from_date.trace.date.date, 'YYYY-MM-DD HH:mm:ss').format('h:mm A') : $startAt;
                                    $endAt = $v.periodRanges[$w][$day] ? moment($v.periodRanges[$w][$day].to_date.trace.date.date, 'YYYY-MM-DD HH:mm:ss').format('h:mm A') : $endAt;
                                }
                                $toolTipHtml += '' +
                                '<tbody>' +
                                '   <tr>' +
                                '       <td><span style=\'background-color:'+$v.color+';color:#333333;padding:0px 5px;\'>'+($i+1)+'</span></td>' +
                                '       <td>'+$title+'</td>' +
                                '       <td>'+$startAt+'</td>' +
                                '       <td>'+$endAt+'</td>' +
                                '   </tr>' +
                                '</tbody>';
                            });
                        $toolTipHtml += '</table>';
                        $toolTipHtml = $toolTipHtml.replace(/"/g, "\\'");
                        $titleContent.push([$w+'_'+$day, $toolTipHtml]);
                        $chtml += '' +
                            '<div class="total-events with-tooltip-month-events" data-wd="'+$w+'_'+$day+'"> events '+$properties.eventsCount+'</div>' +
                            '   <div class="w-100">';

                        $.each($properties.events, function($i, $v){
                            var $toolTipEventHtml = '';
                            var $key = $v.key;
                            var $color = $v.color;
                            $toolTipEventHtml+= nurseslounge_myDashboard_schedule.tableDescription($v);
                            //$toolTipEventHtml = $toolTipEventHtml.replace(/"/g, "\\'");
                            $titleEventContent.push([$key, $toolTipEventHtml, $color]);
                            $chtml += '' +
                                '<div class="month-section with-tooltip-month-event" data-key="'+$key+'" style="background-color: '+$color+';"></div>';
                        });
                        $chtml += '' +
                            '</div>';
                    }
                    $chtml += '' +
                        '</div>'+
                    '</td>';
            });
            $chtml += '' +
                '</tr>';
        });
        $viewMonthTbody.html($chtml).promise().done(function(){
            var $clickBinding;
            var $holdBinding;
            var $template = '' +
                '<div class="tooltip-month-events" role="tooltip">' +
                '   <div class="tooltip-inner"></div>' +
                '</div>';
                if(!libs.isMobile()){
                    $viewMonthTbody.find('.with-tooltip-month-events').each(function () {
                        var $that = $(this);
                        $that.unbind();
                        $that.tooltip({
                            html: true,
                            title:function(){
                                var $wd = $(this).data('wd');
                                var $text = '';
                                $.each($titleContent, function($i, $v){
                                    if($wd == $v[0]){
                                        $text = $v[1];
                                        return false;
                                    }
                                });
                                return $text;
                            },
                            sanitize:false,
                            trigger: 'hover',
                            template:$template,
                            placement:'top'
                        });
                        $that.click(function($e){
                            clearTimeout($clickBinding);
                        });
                    });
                }
            $template = '' +
                '<div class="tooltip-month-event" role="tooltip">' +
                '   <div class="tooltip-inner shadow"></div>' +
                '</div>';
                if(!libs.isMobile()){
                    $viewMonthTbody.find('.with-tooltip-month-event').each(function () {
                        var $that = $(this);
                        $that.unbind();
                        $that.tooltip({
                            html: true,
                            title:function(){
                                var $key = $(this).data('key');
                                var $text = '';
                                var $color = '';
                                $.each($titleEventContent, function($i, $v){
                                    if($key == $v[0]){
                                        $text = $v[1];
                                        $color = $v[2];
                                        return false;
                                    }
                                });
                                setTimeout(function(){
                                    $(".tooltip-month-event .tooltip-inner .event-info-table .event-color").css('color', $color+' !important');
                                }, 1);
                                return $text;
                            },
                            offset:0,
                            sanitize:false,
                            trigger: 'hover',
                            template:$template,
                            placement:'auto'
                        });
                        $that.click(function($e){
                            clearTimeout($clickBinding);
                            var $key = $that.data('key');
                            nurseslounge_myDashboard_schedule.getEventModal({key:$key, user_id: $userId});
                        });
                    });
                }else{
                    $viewMonthTbody.find('.with-tooltip-month-event').each(function(){
                        var $key, $keyHelper;
                        var $that = $(this);
                        $that.unbind().on('mousedown touchstart', function($e){
                            $key = $that.data('key');
                        }).on('mouseup touchend', function ($e) {
                            $keyHelper = $that.data('key');
                            //nurseslounge_myDashboard_schedule.getEventModal({key:$key, user_id: $userId});
                        });
                    });
                }
                //Add new event from the calendar month
                if(!libs.isMobile()) {
                    var $from = '';
                    var $to = '';
                    var $allTimeDay = 1;
                    var $available = 1;
                    var $selection = false;
                    $viewMonthTbody.find('tr td').unbind().on('mousedown touchstart', function ($e) {
                        $e.stopPropagation();
                        $e.preventDefault();
                        var $that = $(this);
                        $from = $that.data('date');
                        $selection = true;
                        $that.addClass('month-focus-selection');
                        /*
                        $holdBinding = setTimeout(function () {
                            clearTimeout($clickBinding);
                            nurseslounge_myDashboard_schedule.switchCalendarTo('week', $from);
                        }, 800);
                        */
                     }).on('mousemove touchmove', function ($e) {
                        $e.stopPropagation();
                        $e.preventDefault();
                        var $that = $(this);
                        $to = $that.data('date');
                        if ($selection && $to != undefined) {
                            $viewMonthTbody.find('tr').each(function () {
                                var $thatTR = $(this);
                                $thatTR.find('td').each(function () {
                                    var $thatTD = $(this);
                                    if (
                                        moment($from, 'YYYY-MM-DD HH:mm:ss') <= moment($thatTD.data('date'), 'YYYY-MM-DD HH:mm:ss') &&
                                        moment($to, 'YYYY-MM-DD HH:mm:ss') >= moment($thatTD.data('date'), 'YYYY-MM-DD HH:mm:ss')) {
                                        $thatTD.addClass('month-focus-selection');
                                    } else {
                                        $thatTD.removeClass('month-focus-selection');
                                    }
                                });
                            });
                        }
                    }).on('mouseup touchend', function ($e) {
                        $e.stopPropagation();
                        $e.preventDefault();
                        var $that = $(this);
                        $to = $that.data('date');
                        if ($selection) {
                            $viewMonthTbody.find('.month-focus-selection').removeClass('month-focus-selection');
                            $selection = false;
                            $clickBinding = setTimeout(function () {
                                /*
                                nurseslounge_myDashboard_schedule.getEventModal({
                                    user_id: $userId,
                                    type: $from == $to ? 'one_time' : 'periodical',
                                    period: $from == $to ? 'consecutive' : 'no_consecutive',
                                    from: $from,
                                    to: $to,
                                    all_time_day: $allTimeDay,
                                    start_at: '',
                                    end_at: '',
                                    available: $available
                                });
                                 */
                            }, 800);
                        }
                        //clearTimeout($holdBinding);
                    });
                }else{
                    /*
                    $viewMonthTbody.find('tr td').unbind().on('mousedown touchstart', function ($e) {
                        $e.stopPropagation();
                        $e.preventDefault();
                        var $that = $(this);
                        $from = $that.data('date');
                        $holdBinding = setTimeout(function () {
                            nurseslounge_myDashboard_schedule.switchCalendarTo('week', $from);
                            $viewMonthTbody.find('.with-tooltip-month-event').unbind('mouseup touchend');
                        }, 800);
                    }).on('mouseup touchend', function ($e) {
                        clearTimeout($holdBinding);
                    });
                     */
                }
        });
        $viewMonth.show();
    },
    createCalendarWeek:function($momentDate, $data){
        var $userId = libs.memoryGet('user_id');
        var $weeks = nurseslounge_myDashboard_schedule.getWeeks($momentDate, $data);
        var $week = $momentDate.clone().week();
        var $day = $momentDate.clone().format('DD');
        $day = libs.pad('00',$day,'l');
        var $currentWeek = $weeks.filter(function($v){
            return $v[0] == $week;
        })[0];
        var $currentDay = $currentWeek[1].filter(function($v){
            return $v[0] == $day;
        })[0];
        var $myCalendar = $("#nurseslounge-home-schedule");
        var $viewMonth = $myCalendar.find(".view-month");
        $viewMonth.hide();
        var $viewWeek = $myCalendar.find(".view-week");
        var $viewDay = $myCalendar.find(".view-day");
        $viewDay.hide();
        var $viewList = $myCalendar.find(".view-list");
        $viewList.hide();
        var $viewWeekThead = $viewWeek.find('.view-week-thead');
        var $viewWeekTbody = $viewWeek.find('.view-week-tbody');
        var $weeksDaysMin = moment.weekdaysMin();
        $weeksDaysMin.unshift('&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
        var $chtml = '';
        $chtml += '<tr>';
        var $titleContent = [];
        var $titleEventContent = [];
        var $clickBinding;
        var $holdBinding;
        $.each($weeksDaysMin, function($i, $v){
            var $content = $v;
            var $properties = $i != 0 ? $currentWeek[1][$i - 1][1] : null;
            if($properties){
                var $w = $properties.trace.week.W;
                var $day = $properties.trace.day.d;
                var $toolTipHtml = '' +
                    '<table class="table border collapse">' +
                    '   <thead class="thead-dark">' +
                    '       <tr>' +
                    '           <th>Event</th>' +
                    '           <th>Title</th>' +
                    '           <th>Start At</th>' +
                    '           <th>End At</th>' +
                    '       </tr>';
                '   </thead>';
                $.each($properties.events, function($i, $v){
                    var $title = $v.title.length <= 15 ? $v.title : $v.title.substring(0, 15) + '...';
                    var $startAt = moment($v.start_at, 'YYYY-MM-DD HH:mm:ss').format('h:mm A');
                    var $endAt = moment($v.end_at, 'YYYY-MM-DD HH:mm:ss').format('h:mm A');
                    if($v.period == 'consecutive' && $v.periodRanges.length > 0){
                        $startAt = $v.periodRanges[$w][$day] ? moment($v.periodRanges[$w][$day].from_date.trace.date.date, 'YYYY-MM-DD HH:mm:ss').format('h:mm A') : $startAt;
                        $endAt = $v.periodRanges[$w][$day] ? moment($v.periodRanges[$w][$day].to_date.trace.date.date, 'YYYY-MM-DD HH:mm:ss').format('h:mm A') : $endAt;
                    }
                    $toolTipHtml += '' +
                        '<tbody>' +
                        '   <tr>' +
                        '       <td><span style=\'background-color:'+$v.color+';color:#333333;padding:0px 5px;\'>'+($i+1)+'</span></td>' +
                        '       <td>'+$title+'</td>' +
                        '       <td>'+$startAt+'</td>' +
                        '       <td>'+$endAt+'</td>' +
                        '   </tr>' +
                        '</tbody>';
                });
                $toolTipHtml += '</table>';
                $toolTipHtml = $toolTipHtml.replace(/"/g, "\\'");
                $titleContent.push([$w+'_'+$day, $toolTipHtml]);
            }
            $chtml += '' +
                '<th class="border w-week">' +
                '   <div class="col-12">'+$content+'</div>';
            if($properties && $properties.eventsCount > 0) {
                $chtml += '<div class="col-8 offset-2 total-events with-tooltip-week-events" data-wd="'+$w+'_'+$day+'"> events '+$properties.eventsCount+'</div>';
            }
            $chtml += '' +
                '</th>';
        });
        $chtml += '</tr><tr>';
        var $before = false;
        $.each($weeksDaysMin, function($i, $v){
            var $content = $i != 0 ? $currentWeek[1][$i - 1][0] : $v;
            var $class = 'before';
            if($before){
                $class = 'after';
            }
            $chtml += '' +
                '<td class="border bg-secondary-'+$class+'">' +
                '   <span class="month-tag">'+$content+'</span>' +
                '</td>';
            if($currentDay[0] == $content){
                $before = true;
            }
        });
        $chtml += '</tr>';
        $viewWeekThead.html($chtml).promise().done(function(){
            var $template = '' +
                '<div class="tooltip-month-events" role="tooltip">' +
                '   <div class="tooltip-inner"></div>' +
                '</div>';
            if(!libs.isMobile()){
                $viewWeekThead.find('.with-tooltip-week-events').each(function () {
                    var $that = $(this);
                    $that.unbind();
                    $that.tooltip({
                        html: true,
                        title:function(){
                            var $wd = $(this).data('wd');
                            var $text = '';
                            $.each($titleContent, function($i, $v){
                                if($wd == $v[0]){
                                    $text = $v[1];
                                    return false;
                                }
                            });
                            return $text;
                        },
                        sanitize:false,
                        trigger: 'hover',
                        template:$template,
                        placement:'bottom'
                    });
                    $that.click(function($e){
                        clearTimeout($clickBinding);
                    });
                });
            }
        });
        $chtml = '';
        for(var $halfHour = 0;  $halfHour < 48; $halfHour++){
            var $hours = Math.floor($halfHour/2);
            var $min = (($halfHour+1)%2) > 0 ? '00' : '30';
            var $time = moment($hours + ' ' +$min, 'HH mm');
            $chtml += '' +
                '<tr>' +
                '    <td class="w-week">' +
                '        <div class="text-center mt-3 rotate-mobile">' +
                $time.clone().format('hh:mm a') +
                '        </div>' +
                '    </td>';

            $.each($currentWeek[1], function($i, $v){
                var $now = moment();
                var $properties = $v[1];
                var $date = $v[2];
                var $dateHtml = $hours+' '+$min+' '+$date.format('DD MM YYYY');
                var $startOfDay = moment('00 00 00 '+$date.format('DD MM YYYY'), 'HH mm ss DD MM YYYY');
                var $endOfDay = moment('23 59 59 '+$date.format('DD MM YYYY'), 'HH mm ss DD MM YYYY');
                var $from = moment($dateHtml, 'HH mm DD MM YYYY');
                var $to = $from.clone().add(30, 'minutes');
                var $dayRange = moment().range($startOfDay, $endOfDay);
                var $isToday = $dayRange.contains($now) ? 'week-today': '';
                var $timeRange = moment().range($from, $to);
                var $isNow = $timeRange.contains($now) ? 'active': '';
                var $diffInMinutes = $now.diff($from, 'minutes');
                var $top = (parseInt($diffInMinutes)*2);
                $chtml += '' +
                    '        <td class="border no-margin no-padding w-week '+$isToday+'" ' +
                    '           data-from="'+$from.format('YYYY-MM-DD HH:mm:ss')+'"' +
                    '           data-to="'+$to.format('YYYY-MM-DD HH:mm:ss')+'"' +
                    '>'+
                    '<div class="w-100 week-timeline '+$isNow+'"  style="top:'+$top+'px;"></div>';
                if($properties.eventsCount > 0){
                    $.each($properties.events, function($i, $v){
                        var $toolTipEventHtml = '';
                        var $key = $v.key;
                        var $color = $v.color;
                        $toolTipEventHtml+= nurseslounge_myDashboard_schedule.tableDescription($v);
                        //$toolTipEventHtml = $toolTipEventHtml.replace(/"/g, "\\'");
                        $titleEventContent.push([$key, $toolTipEventHtml, $color]);
                        var $w = $properties.trace.week.W;
                        var $day = $properties.trace.day.d;
                        var $startAt = moment($v.start_at, 'YYYY-MM-DD HH:mm:ss');
                        var $endAt = moment($v.end_at, 'YYYY-MM-DD HH:mm:ss');
                        if($v.type == 'periodical'){
                            if($v.period != 'consecutive' && $v.periodRanges.length > 0){
                                $startAt = $v.periodRanges[$w][$day] ? moment($v.periodRanges[$w][$day].from_date.trace.date.date, 'YYYY-MM-DD HH:mm:ss') : $startAt;
                                $endAt = $v.periodRanges[$w][$day] ? moment($v.periodRanges[$w][$day].to_date.trace.date.date, 'YYYY-MM-DD HH:mm:ss') : $endAt;
                            }
                        }
                        var $range = moment().range($startAt, $endAt);
                        if($range.contains($from)) {
                            $chtml += '' +
                                '<div class="week-section with-tooltip-week-event" data-key="'+$key+'" style="background-color: '+$color+';"></div>';
                        }
                    });
                }
                $chtml += '' +
                    '        </td>';

            });
            $chtml += '' +
                '</tr>';
        }
        $viewWeekTbody.html($chtml).promise().done(function(){
            var $template = '' +
                '<div class="tooltip-month-event" role="tooltip">' +
                '   <div class="tooltip-inner shadow"></div>' +
                '</div>';
            if(!libs.isMobile()){
                $viewWeekTbody.find('.with-tooltip-week-event').each(function () {
                    var $that = $(this);
                    $that.unbind();
                    $that.tooltip({
                        html: true,
                        title:function(){
                            var $key = $(this).data('key');
                            var $text = '';
                            var $color = '';
                            $.each($titleEventContent, function($i, $v){
                                if($key == $v[0]){
                                    $text = $v[1];
                                    $color = $v[2];
                                    return false;
                                }
                            });
                            setTimeout(function(){
                                $(".tooltip-month-event .tooltip-inner .event-info-table .event-color").css('color', $color+' !important');
                            }, 1);
                            return $text;
                        },
                        offset:0,
                        sanitize:false,
                        trigger: 'hover',
                        template:$template,
                        placement:'auto'
                    });
                    $that.click(function($e){
                        clearTimeout($clickBinding);
                        var $key = $that.data('key');
                        nurseslounge_myDashboard_schedule.getEventModal({key:$key, user_id: $userId});
                    });
                });
            }else{
                $viewWeekTbody.find('.with-tooltip-week-event').each(function () {
                    var $key, $keyHelper;
                    var $that = $(this);
                    $that.unbind().on('mousedown touchstart', function($e){
                        $key = $that.data('key');
                    }).on('mouseup touchend', function ($e) {
                        $keyHelper = $that.data('key');
                        //nurseslounge_myDashboard_schedule.getEventModal({key:$key, user_id: $userId});
                    });
                });
            }
            //Add new event from the calendar week
            if(!libs.isMobile()) {
                var $from = '';
                var $to = '';
                var $available = 1;
                var $selection = false;
                var $dayHelper = [];
                var $senseY;
                var $senseX;
                var $sense;
                $viewWeekTbody.find('tr td').unbind().on('mousedown touchstart', function($e){
                    $e.stopPropagation();
                    $e.preventDefault();
                    var $that = $(this);
                    $dayHelper.length = 0;
                    $from = $that.data('from');
                    $to = $that.data('to');
                    if($to != undefined) {
                        $that.addClass('week-focus-selection');
                        $dayHelper.push(moment($that.data('to'), 'YYYY-MM-DD HH:mm:ss'));
                        $selection = true;
                        $senseY = true;
                        $senseX = true;
                    }
                    /*
                    $holdBinding = setTimeout(function(){
                        clearTimeout($clickBinding);
                        nurseslounge_myDashboard_schedule.switchCalendarTo('day', $from);
                    }, 800);
                     */
                }).on('mousemove touchmove', function($e){
                    $e.stopPropagation();
                    $e.preventDefault();
                    var $that = $(this);
                    $to = $that.data('to');
                    if($selection && $to != undefined){
                        if($dayHelper.length >= 2){
                            var $currentDay = $dayHelper[0].format('DD');
                            var $toDay = moment($to, 'YYYY-MM-DD HH:mm:ss').format('DD');
                            var $currentHour = $dayHelper[0].format('HH:mm:ss');
                            var $toHour = moment($to, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss');
                            $sense = $dayHelper[0].format('DD') == $dayHelper[1].format('DD') ? 'y' : 'x';
                            if($sense == 'y' && $senseY){
                                $senseX = false;
                                if(
                                    $currentDay == $toDay &&
                                    moment($currentHour, 'HH:mm:ss')
                                    <=
                                    moment($toHour, 'HH:mm:ss')
                                ){
                                    $that.addClass('week-focus-selection');
                                }
                                $viewWeekTbody.find('.week-focus-selection').each(function(){
                                    var $toHourHelper = moment($(this).data('to'), 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss');
                                    if(
                                        moment($toHour, 'HH:mm:ss')
                                        <
                                        moment($toHourHelper, 'HH:mm:ss')
                                    ){
                                        $that.removeClass('week-focus-selection');
                                    }
                                });
                            }
                            if($sense == 'x' && $senseX){
                                $senseY = false;
                                if(
                                    $currentHour == $toHour &&
                                    (parseInt($dayHelper[0].format('DDD')) * parseInt($dayHelper[0].format('YYYY')))
                                    <=
                                    (parseInt(moment($to, 'YYYY-MM-DD HH:mm:ss').format('DDD')) * parseInt(moment($to, 'YYYY-MM-DD HH:mm:ss').format('YYYY')))
                                ){
                                    $that.addClass('week-focus-selection');
                                }
                                $viewWeekTbody.find('.week-focus-selection').each(function(){
                                    var $toDayHelper = parseInt(moment($(this).data('to'), 'YYYY-MM-DD HH:mm:ss').format('DDD')) * parseInt(moment($(this).data('to'), 'YYYY-MM-DD HH:mm:ss').format('YYYY'));
                                    if(
                                        (parseInt(moment($to, 'YYYY-MM-DD HH:mm:ss').format('DDD')) * parseInt(moment($to, 'YYYY-MM-DD HH:mm:ss').format('YYYY')))
                                        <
                                        $toDayHelper
                                    ){
                                        $that.removeClass('week-focus-selection');
                                    }
                                });
                            }
                        }else{
                            var $newDate = moment($to, 'YYYY-MM-DD HH:mm:ss');
                            $.each($dayHelper, function($i, $v){
                                if($v < $newDate){
                                    $dayHelper.push($newDate);
                                    $that.addClass('week-focus-selection');
                                    return false;
                                }
                            });
                        }
                    }
                }).on('mouseup touchend', function($e){
                    $e.stopPropagation();
                    $e.preventDefault();
                    var $that = $(this);
                    var $eventsOfDate = $that.data('from');
                    $to = $that.data('to');
                    if($selection){
                        $dayHelper.length = 0;
                        $viewWeekTbody.find('.week-focus-selection').removeClass('week-focus-selection');
                        $selection = false;
                        $clickBinding = setTimeout(function(){
                            /*
                            nurseslounge_myDashboard_schedule.getEventModal({
                                user_id: $userId,
                                type: $sense == 'y' ? 'one_time' : 'periodical',
                                period: $sense == 'y' ? 'consecutive': 'no_consecutive',
                                from: $from,
                                to: $to,
                                all_time_day:0,
                                start_at: $from,
                                end_at: $to,
                                available:$available
                            });
                             */
                        }, 800);
                    }
                    //clearTimeout($holdBinding);
                });
            }else{
                /*
                $viewWeekTbody.find('tr td').unbind().on('mousedown touchstart', function ($e) {
                    $e.stopPropagation();
                    $e.preventDefault();
                    var $that = $(this);
                    $from = $that.data('from');
                    $holdBinding = setTimeout(function () {
                        nurseslounge_myDashboard_schedule.switchCalendarTo('day', $from);
                        $viewWeekTbody.find('.with-tooltip-week-event').unbind('mouseup touchend');
                    }, 800);
                }).on('mouseup touchend', function ($e) {
                    clearTimeout($holdBinding);
                });
                 */
            }
        });
        $viewWeek.show();
    },
    createCalendarDay:function($momentDate, $data){
        var $userId = libs.memoryGet('user_id');
        var $weeks = nurseslounge_myDashboard_schedule.getWeeks($momentDate, $data);
        var $week = $momentDate.clone().week();
        var $day = $momentDate.clone().format('DD');
        $day = libs.pad('00',$day,'l');
        var $currentWeek = $weeks.filter(function($v){
            return $v[0] == $week;
        })[0];
        var $currentDay = $currentWeek[1].filter(function($v){
            return $v[0] == $day;
        })[0];
        var $myCalendar = $("#nurseslounge-home-schedule");
        var $viewMonth = $myCalendar.find(".view-month");
        $viewMonth.hide();
        var $viewWeek = $myCalendar.find(".view-week");
        $viewWeek.hide();
        var $viewDay = $myCalendar.find(".view-day");
        var $viewList = $myCalendar.find(".view-list");
        $viewList.hide();
        var $viewDayThead = $viewDay.find('.view-day-thead');
        var $viewDayTbody = $viewDay.find('.view-day-tbody');
        var $chtml = '';
        $chtml += '<tr>';
        var $titleContent = [];
        var $titleEventContent = [];
        var $clickBinding;
        var $holdBinding;
        for(var $i = 0; $i<=1 ; $i++) {
            var $content = $i == 0 ? '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' : $currentDay[$i].trace.day.l + ' - ' + $currentDay[$i].trace.day.d;
            var $width = $i == 0 ? 'w-week' : 'w-100';
            var $properties = $i != 0 ? $currentDay[$i] : null;
            if ($properties) {
                var $w = $properties.trace.week.W;
                var $day = $properties.trace.day.d;
                var $toolTipHtml = '' +
                    '<table class="table border collapse">' +
                    '   <thead class="thead-dark">' +
                    '       <tr>' +
                    '           <th>Event</th>' +
                    '           <th>Title</th>' +
                    '           <th>Start At</th>' +
                    '           <th>End At</th>' +
                    '       </tr>';
                '   </thead>';
                $.each($properties.events, function ($i, $v) {
                    var $title = $v.title.length <= 15 ? $v.title : $v.title.substring(0, 15) + '...';
                    var $startAt = moment($v.start_at, 'YYYY-MM-DD HH:mm:ss').format('h:mm A');
                    var $endAt = moment($v.end_at, 'YYYY-MM-DD HH:mm:ss').format('h:mm A');
                    if ($v.period == 'consecutive' && $v.periodRanges.length > 0) {
                        $startAt = $v.periodRanges[$w][$day] ? moment($v.periodRanges[$w][$day].from_date.trace.date.date, 'YYYY-MM-DD HH:mm:ss').format('h:mm A') : $startAt;
                        $endAt = $v.periodRanges[$w][$day] ? moment($v.periodRanges[$w][$day].to_date.trace.date.date, 'YYYY-MM-DD HH:mm:ss').format('h:mm A') : $endAt;
                    }
                    $toolTipHtml += '' +
                        '<tbody>' +
                        '   <tr>' +
                        '       <td><span style=\'background-color:' + $v.color + ';color:#333333;padding:0px 5px;\'>' + ($i + 1) + '</span></td>' +
                        '       <td>' + $title + '</td>' +
                        '       <td>' + $startAt + '</td>' +
                        '       <td>' + $endAt + '</td>' +
                        '   </tr>' +
                        '</tbody>';
                });
                $toolTipHtml += '</table>';
                $toolTipHtml = $toolTipHtml.replace(/"/g, "\\'");
                $titleContent.push([$w + '_' + $day, $toolTipHtml]);
            }
            $chtml += '' +
                '<td class="border ' + $width + '">' +
                '   <div class="col-12 text-center mt-3">' +
                '       <b>' + $content + '</b>' +
                '   </div>';
            if ($properties && $properties.eventsCount > 0) {
                $chtml += '<div class="col-4 offset-4 total-events with-tooltip-day-events" data-wd="' + $w + '_' + $day + '"> events ' + $properties.eventsCount + '</div>';
            }
            $chtml += '</td>';
        }
        $chtml += '</tr>';
        $viewDayThead.html($chtml).promise().done(function(){
            var $template = '' +
                '<div class="tooltip-month-events" role="tooltip">' +
                '   <div class="tooltip-inner"></div>' +
                '</div>';
            if(!libs.isMobile()){
                $viewDayThead.find('.with-tooltip-day-events').each(function () {
                    var $that = $(this);
                    $that.unbind();
                    $that.tooltip({
                        html: true,
                        title:function(){
                            var $wd = $(this).data('wd');
                            var $text = '';
                            $.each($titleContent, function($i, $v){
                                if($wd == $v[0]){
                                    $text = $v[1];
                                    return false;
                                }
                            });
                            return $text;
                        },
                        sanitize:false,
                        trigger: 'hover',
                        template:$template,
                        placement:'bottom'
                    });
                    $that.click(function($e){
                        clearTimeout($clickBinding);
                    });
                });
            }
        });
        $chtml = '';
        for(var $halfHour = 0;  $halfHour < 48; $halfHour++){
            var $hours = Math.floor($halfHour/2);
            var $min = (($halfHour+1)%2) > 0 ? '00' : '30';
            var $time = moment($hours + ' ' +$min, 'HH mm');
            $chtml += '' +
                '<tr>' +
                '    <td class="w-week cursor" data-from="'+$time.clone().format('YYYY-MM-DD HH:mm:ss')+'" data-to="'+$time.clone().add(30, 'minutes').format('YYYY-MM-DD HH:mm:ss')+'">' +
                '        <div class="text-center mt-3 rotate-mobile">' +
                $time.clone().format('hh:mm a') +
                '        </div>' +
                '    </td>';

                var $now = moment();
                var $properties = $currentDay[1];
                var $date = $currentDay[2];
                var $dateHtml = $hours+' '+$min+' '+$date.format('DD MM YYYY');
                var $startOfDay = moment('00 00 00 '+$date.format('DD MM YYYY'), 'HH mm ss DD MM YYYY');
                var $endOfDay = moment('23 59 59 '+$date.format('DD MM YYYY'), 'HH mm ss DD MM YYYY');
                var $from = moment($dateHtml, 'HH mm DD MM YYYY');
                var $to = $from.clone().add(30, 'minutes');
                var $dayRange = moment().range($startOfDay, $endOfDay);
                var $isToday = $dayRange.contains($now) ? 'day-today': '';
                var $timeRange = moment().range($from, $to);
                var $isNow = $timeRange.contains($now) ? 'active': '';
                var $diffInMinutes = $now.diff($from, 'minutes');
                var $top = (parseInt($diffInMinutes)*2);
                $chtml += '' +
                    '        <td class="border no-margin no-padding w-100 '+$isToday+'" ' +
                    '           data-from="'+$from.format('YYYY-MM-DD HH:mm:ss')+'"' +
                    '           data-to="'+$to.format('YYYY-MM-DD HH:mm:ss')+'"' +
                    '>'+
                    '<div class="w-100 week-timeline '+$isNow+'"  style="top:'+$top+'px;"></div>';
                if($properties.eventsCount > 0){
                    $.each($properties.events, function($i, $v){
                        var $toolTipEventHtml = '';
                        var $type = $v.type;
                        var $by = '';
                        switch($type){
                            case 'one_time':
                                $type = 'One time event';
                                break;
                            case 'periodical':
                                $type = 'Periodical';
                                break;
                            case 'consecutive':
                                $type = 'Consecutive';
                                break;
                            case 'no_consecutive':
                                $type = 'No Consecutive';
                                break;
                            case 'weekly':
                                $type = 'Weekly';
                                break;
                            case 'monthly':
                                $type = 'Monthly';
                                break;
                        }
                        if($v.owner_system == 1){
                            $by = 'Nurses Lounge';
                        }
                        if($v.ownerUser && $v.ownerUser.email){
                            $by = $v.ownerUser.long_name;
                        }
                        if($v.ownerLounge && $v.ownerLounge.name){
                            $by = $v.ownerLounge.name;
                        }
                        var $title = $v.title;
                        $title = $title.length > 20 ? $title.substring(0, 20) + '...' : $title;
                        //var $name = $v.name;
                        //$name = $name.length > 20 ? $name.substring(0, 20) + '...' : $name;
                        //var $description = $v.description;
                        //$description = $description.length > 30 ? $description.substring(0, 30) + '...' : $description;
                        //var $image;
                        //if($v.owner_system == 1){
                        //    $image = '/bimg/Login/small-logo.jpeg';
                        //}
                        //if($v.ownerUser && $v.ownerUser.email){
                        //    $image = $v.ownerUser.profile_image_root_friend+'?resize=65';
                        //}
                        //if($v.ownerLounge && $v.ownerLounge.name){
                        //    $image = $v.ownerLounge.logo_root_lounge+'?resize=65';
                        //}
                        var $key = $v.key;
                        var $color = $v.color;
                        $toolTipEventHtml+= nurseslounge_myDashboard_schedule.tableDescription($v);
                        //$toolTipEventHtml = $toolTipEventHtml.replace(/"/g, "\\'");
                        $titleEventContent.push([$key, $toolTipEventHtml, $color]);
                        var $w = $properties.trace.week.W;
                        var $day = $properties.trace.day.d;
                        var $startAt = moment($v.start_at, 'YYYY-MM-DD HH:mm:ss');
                        var $endAt = moment($v.end_at, 'YYYY-MM-DD HH:mm:ss');
                        if($v.type == 'periodical'){
                            if($v.period != 'consecutive' && $v.periodRanges.length > 0){
                                $startAt = $v.periodRanges[$w][$day] ? moment($v.periodRanges[$w][$day].from_date.trace.date.date, 'YYYY-MM-DD HH:mm:ss') : $startAt;
                                $endAt = $v.periodRanges[$w][$day] ? moment($v.periodRanges[$w][$day].to_date.trace.date.date, 'YYYY-MM-DD HH:mm:ss') : $endAt;
                            }
                        }
                        var $fontColor;
                        switch($color.toUpperCase()){
                            case '#00FF00':
                            $fontColor = '#46565f';
                            break;
                            case '#B03060':
                            $fontColor = '#cccccc';
                            break;
                            case '#A020F0':
                            $fontColor = '#f1f1f1';
                            break;
                            case '#C0C0C0':
                            $fontColor = '#000000';
                            break;
                            case '#FF00FF':
                            $fontColor = '#ffffff';
                            break;
                            case '#00FFFF':
                            $fontColor = '#46565f';
                            break;
                            case '#808080':
                            $fontColor = '#f1f1f1';
                            break;
                            case '#008000':
                            $fontColor = '#f1f1f1';
                            break;
                            case '#7F0000':
                            $fontColor = '#f1f1f1';
                            break;
                            case '#7F007F':
                            $fontColor = '#f1f1f1';
                            break;
                        }
                        var $range = moment().range($startAt, $endAt);
                        if($range.contains($from)) {
                            $chtml += '' +
                                '<div class="row day-section with-tooltip-day-event text-center" data-key="'+$key+'" style="background-color: '+$color+';color:'+$fontColor+';">' +
                                //'   <div class="col-2 m-0 p-1 rounded-circle" style="background-color: '+$color+';">' +
                                //'       <img src="'+$image+'" class="img-fluid day-img">' +
                                //'   </div>' +
                                '   <div class="col-10 m-0 p-0">' +
                                '       <b>'+ $type + '</b> by ' + $by + ' - ' + $title + '<small> from ' + $v.start_at +' to ' + $v.end_at + '</small> ' +
                                '   </div>' +
                                //'   <div class="col-12 m-0 p-0">' +
                                //'       <small>'+$description+'</small>' +
                                //'   </div>' +
                                '</div>';
                        }
                    });
                }
                $chtml += '' +
                    '   </td>'+
                '</tr>';
        }
        $viewDayTbody.html($chtml).promise().done(function(){
            var $template = '' +
                '<div class="tooltip-month-event" role="tooltip">' +
                '   <div class="tooltip-inner shadow"></div>' +
                '</div>';
            if(!libs.isMobile()){
                $viewDayTbody.find('.with-tooltip-day-event').each(function () {
                    var $that = $(this);
                    $that.unbind();
                    $that.tooltip({
                        html: true,
                        title:function(){
                            var $key = $(this).data('key');
                            var $text = '';
                            var $color = '';
                            $.each($titleEventContent, function($i, $v){
                                if($key == $v[0]){
                                    $text = $v[1];
                                    $color = $v[2];
                                    return false;
                                }
                            });
                            setTimeout(function(){
                                $(".tooltip-month-event .tooltip-inner .event-info-table .event-color").css('color', $color+' !important');
                            }, 1);
                            return $text;
                        },
                        offset:0,
                        sanitize:false,
                        trigger: 'hover',
                        template:$template,
                        placement:'auto'
                    });
                    $that.click(function($e){
                        clearTimeout($clickBinding);
                        var $key = $that.data('key');
                        nurseslounge_myDashboard_schedule.getEventModal({key:$key, user_id: $userId});
                    });
                });
            }else{
                $viewDayTbody.find('.with-tooltip-day-event').each(function(){
                    var $key, $keyHelper;
                    var $that = $(this);
                    $that.unbind().on('mousedown touchstart', function($e){
                        $key = $that.data('key');
                    }).on('mouseup touchend', function ($e) {
                        $keyHelper = $that.data('key');
                        //nurseslounge_myDashboard_schedule.getEventModal({key:$key, user_id: $userId});
                    });
                });
            }
            //Add new event from the calendar day
            if(!libs.isMobile()){
                var $from = '';
                var $to = '';
                var $available = 1;
                var $selection = false;
                var $dayHelper = [];
                var $senseY;
                var $senseX;
                var $sense;
                $viewDayTbody.find('tr td').unbind().on('mousedown touchstart', function($e){
                    $e.stopPropagation();
                    $e.preventDefault();
                    var $that = $(this);
                    $dayHelper.length = 0;
                    $from = $that.data('from');
                    $to = $that.data('to');
                    if($to != undefined) {
                        $that.addClass('week-focus-selection');
                        $dayHelper.push(moment($that.data('to'), 'YYYY-MM-DD HH:mm:ss'));
                        $selection = true;
                        $senseY = true;
                        $senseX = true;
                    }
                    /*
                    $holdBinding = setTimeout(function(){
                        clearTimeout($clickBinding);
                        nurseslounge_myDashboard_schedule.switchCalendarTo('list', $from);
                    }, 800);
                     */
                }).on('mousemove touchmove', function($e){
                    $e.stopPropagation();
                    $e.preventDefault();
                    var $that = $(this);
                    $to = $that.data('to');
                    if($selection && $to != undefined){
                        if($dayHelper.length >= 2){
                            var $currentDay = $dayHelper[0].format('DD');
                            var $toDay = moment($to, 'YYYY-MM-DD HH:mm:ss').format('DD');
                            var $currentHour = $dayHelper[0].format('HH:mm:ss');
                            var $toHour = moment($to, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss');
                            $sense = $dayHelper[0].format('DD') == $dayHelper[1].format('DD') ? 'y' : 'x';
                            if($sense == 'y' && $senseY){
                                $senseX = false;
                                if(
                                    $currentDay == $toDay &&
                                    moment($currentHour, 'HH:mm:ss')
                                    <=
                                    moment($toHour, 'HH:mm:ss')
                                ){
                                    $that.addClass('week-focus-selection');
                                }
                                $viewDayTbody.find('.week-focus-selection').each(function(){
                                    var $toHourHelper = moment($(this).data('to'), 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss');
                                    if(
                                        moment($toHour, 'HH:mm:ss')
                                        <
                                        moment($toHourHelper, 'HH:mm:ss')
                                    ){
                                        $that.removeClass('week-focus-selection');
                                    }
                                });
                            }
                        }else{
                            var $newDate = moment($to, 'YYYY-MM-DD HH:mm:ss');
                            $.each($dayHelper, function($i, $v){
                                if($v < $newDate){
                                    $dayHelper.push($newDate);
                                    $that.addClass('week-focus-selection');
                                    return false;
                                }
                            });
                        }
                    }
                }).on('mouseup touchend', function($e){
                    $e.stopPropagation();
                    $e.preventDefault();
                    var $that = $(this);
                    $to = $that.data('to');
                    if($selection){
                        $dayHelper.length = 0;
                        $viewDayTbody.find('.week-focus-selection').removeClass('week-focus-selection');
                        $selection = false;
                        $clickBinding = setTimeout(function(){
                            /*
                            nurseslounge_myDashboard_schedule.getEventModal({
                                user_id: $userId,
                                type: 'one_time',
                                period: 'consecutive',
                                from: $from,
                                to: $to,
                                all_time_day:0,
                                start_at: $from,
                                end_at: $to,
                                available:$available
                            });
                             */
                        }, 800);
                    }
                    //clearTimeout($holdBinding);
                });
            }else{
                /*
                $viewDayTbody.find('tr td').unbind().on('mousedown touchstart', function ($e) {
                    $e.stopPropagation();
                    $e.preventDefault();
                    var $that = $(this);
                    $from = $that.data('from');
                    $holdBinding = setTimeout(function () {
                        nurseslounge_myDashboard_schedule.switchCalendarTo('list', $from);
                        $viewDayTbody.find('.with-tooltip-day-event').unbind('mouseup touchend');
                    }, 800);
                }).on('mouseup touchend', function ($e) {
                    clearTimeout($holdBinding);
                });
                 */
            }
        });
        $viewDay.show();
    },
    switchCalendarTo:function($selectedView, $date){
        var $userId = libs.memoryGet('user_id');
        var $myCalendar = $("#nurseslounge-home-schedule");
        var $timeZone = $myCalendar.find(".time-zone");
        var $area = $timeZone.data('area');
        var $params = $.extend({}, {user_id:$userId, area:$area});
        var $selectedDate = moment($date, 'YYYY-MM-DD HH:mm:ss');
        switch ($selectedView) {
            case 'month':{
                $params = $.extend({}, $params, {month:$selectedDate.clone().startOf('month').format('DD-MM-YYYY')});
                break;
            }
            case 'week':{
                $params = $.extend({}, $params, {week:$selectedDate.clone().startOf('week').format('DD-MM-YYYY')});
                break;
            }
            case 'day':{
                $params = $.extend({}, $params, {week:$selectedDate.clone().startOf('week').format('DD-MM-YYYY')});
                break;
            }
            case 'list':{
                $params = $.extend({}, $params, {week:$selectedDate.clone().startOf('week').format('DD-MM-YYYY')});
                break;
            }
        }
        nurseslounge_myDashboard_schedule.get($params, function($data){
            nurseslounge_myDashboard_schedule.createCalendar($selectedView, $selectedDate.clone(), $data);
        });
        nurseslounge_myDashboard_schedule.selectedView = $selectedView;
    },
    tableDescription:function($v){
        var $title = $v.title;
        var $description = $v.description;
        var $link = $v.link ? 'Yes' : 'No';
        var $allTimeDay = $v.all_time_day === 1;
        var $fromDay = moment($v.from, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY');
        var $toDay = moment($v.to, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY');
        var $fromHour = moment($v.start_at, 'YYYY-MM-DD HH:mm:ss').format('h:mm A');
        var $toHour = moment($v.end_at, 'YYYY-MM-DD HH:mm:ss').format('h:mm A');
        var $include = $v.include;
        $include = $include ? $include.charAt(0).toUpperCase() + $include.slice(1) : null;
        var $days = $v.days;
        $days = $days ? $days.split(',').join(', ') : '';

        var $chtml = '' +
        '<div class="row m-0">   ' +
        '    <div class="col-12 border-bottom event-info-head text-left"> ';

        /*Top Window Init*/
        $chtml +='' +
        '        <div class="row px-4 py-2 align-items-center">';
        if($v.owner_system == 1){
            $chtml +='' +
                '   <div class="col-5 w80">' +
                '       <img src=\'/bimg/Login/small-logo.jpeg\' class="img-fluid">' +
                '   </div>' +
                '   <div class="col-7 p-0">' +
                '       <h4>Nurses Lounge</h4>' +
                '   </div>';
        }
        if($v.ownerUser && $v.ownerUser.email){
            $chtml +='' +
                '   <div class="col-5 w80">' +
                '       <img src=\''+$v.ownerUser.profile_image_root_friend+'?resize=65\' class="img-fluid">' +
                '   </div>' +
                '   <div class="col-7 p-0">' +
                '       <h4>'+$v.ownerUser.long_name+'</h4>' +
                //'       <h4>'+$v.ownerUser.email+'</h4>' +
                '       <h5>'+$v.ownerUser.profile.profile+'</h5>' +
                '   </div>';
        }
        if($v.ownerLounge && $v.ownerLounge.name){
            $chtml +='' +
                '   <div class="col-5 w80">' +
                '       <img src=\''+$v.ownerLounge.logo_root_lounge+'?resize=65\' class="img-fluid">' +
                '   </div>' +
                '   <div class="col-7 p-0">' +
                '       <h4>'+$v.ownerLounge.name+'</h4>' +
                '       <h5>'+$v.ownerLounge.lounge_type.type+'</h5>' +
                '   </div>';
        }
        $chtml += '' +
            '</div>' +
            '</div>' +
            '<div class="col-12 event-info-table py-2 px-5">';
        /*Top Window End*/
        /*Top Window Table Init*/
        $chtml+= '' +
        '<table>' +
        '<tbody>';

        $chtml+= '' +
        '   <tr>' +
        '       <th>Title</th>' +
        '       <td>'+$title+'</td>' +
        '   </tr>' +
        '   <tr>' +
        '       <th>Description</th>' +
        '       <td>'+$description+'</td>' +
        '   </tr>' +
        '   <tr>' +
        '       <th>Link</th>' +
        '       <td>'+$link+'</td>' +
        '   </tr>';
        if($v.type == 'one_time'){
            $chtml+= '' +
                //'   <tr>' +
                //'       <th>Event Type</th>' +
                //'       <td class="event-color">One time event</td>' +
                //'   </tr>' +
                '   <tr>' +
                '       <th>Event Day</th>' +
                '       <td>'+$fromDay+'</td>' +
                '   </tr>';
            if($allTimeDay){
                $chtml+= '' +
                    '   <tr>' +
                    '       <th>Schedule</th>' +
                    '       <td>All Day</td>' +
                    '   </tr>';
            }else{
                $chtml+= '' +
                    '   <tr>' +
                    '       <th>Schedule</th>' +
                    '       <td>'+$fromHour+' to '+$toHour+'</td>' +
                    '   </tr>';
            }
        }
        if($v.type == 'periodical'){
            //$chtml+= '' +
            //    '   <tr>' +
            //    '       <th>Event Type</th>' +
            //    '       <td class="event-color">Periodical</td>' +
            //    '   </tr>';
            if($v.period == 'consecutive'){
                $chtml+= '' +
                    '   <tr>' +
                    '       <th>Period</th>' +
                    '       <td>One-time event</td>' +
                    '   </tr>';
                if($allTimeDay){
                    $chtml+= '' +
                        '   <tr>' +
                        '       <th>Duration</th>' +
                        '       <td>'+$fromDay+' to '+$toDay+'</td>' +
                        '   </tr>'+
                        '   <tr>' +
                        '       <th>Schedule</th>' +
                        '       <td>All Day</td>' +
                        '   </tr>';
                }else{
                    $chtml+= '' +
                        '   <tr>' +
                        '       <th>Duration</th>' +
                        '       <td>'+$fromDay+' '+$fromHour+'\n to \n'+$toDay+' '+$toHour+'</td>' +
                        '   </tr>';
                }
            }
            if($v.period == 'no_consecutive'){
                $chtml+= '' +
                    '   <tr>' +
                    '       <th>Period</th>' +
                    '       <td>No Consecutive</td>' +
                    '   </tr>';
                if($allTimeDay){
                    $chtml+= '' +
                        '   <tr>' +
                        '       <th>Duration</th>' +
                        '       <td>'+$fromDay+' to '+$toDay+'</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <th>Schedule</th>' +
                        '       <td>All Day</td>' +
                        '   </tr>';
                }else{
                    $chtml+= '' +
                        '   <tr>' +
                        '       <th>Duration</th>' +
                        '       <td>'+$fromDay+' to '+$toDay+'</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <th>Schedule</th>' +
                        '       <td>'+$fromHour+' to '+$toHour+'</td>' +
                        '   </tr>';
                }
            }
            if($v.period == 'weekly'){
                $chtml+= '' +
                    '   <tr>' +
                    '       <th>Period</th>' +
                    '       <td>Reoccurring event</td>' +
                    '   </tr>';
                if($allTimeDay){
                    $chtml+= '' +
                        '   <tr>' +
                        '       <th>Duration</th>' +
                        '       <td>'+$fromDay+' to '+$toDay+'</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <th>Schedule</th>' +
                        '       <td>All Day</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <th>'+$include+'</th>' +
                        '       <td>'+$days+'</td>' +
                        '   </tr>';
                }else{
                    $chtml+= '' +
                        '   <tr>' +
                        '       <th>Duration</th>' +
                        '       <td>'+$fromDay+' to '+$toDay+'</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <th>Schedule</th>' +
                        '       <td>'+$fromHour+' to '+$toHour+'</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <th>'+$include+'</th>' +
                        '       <td>'+$days+'</td>' +
                        '   </tr>';
                }
            }
            if($v.period == 'monthly'){
                $chtml+= '' +
                    '   <tr>' +
                    '       <th>Period</th>' +
                    '       <td>Monthly</td>' +
                    '   </tr>';
                if($allTimeDay){
                    $chtml+= '' +
                        '   <tr>' +
                        '       <th>Duration</th>' +
                        '       <td>'+$fromDay+' to '+$toDay+'</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <th>Schedule</th>' +
                        '       <td>All Day</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <th>'+$include+' day(s)</th>' +
                        '       <td>'+$days+'</td>' +
                        '   </tr>';
                }else{
                    $chtml+= '' +
                        '   <tr>' +
                        '       <th>Duration</th>' +
                        '       <td>'+$fromDay+' to '+$toDay+'</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <th>Schedule</th>' +
                        '       <td>'+$fromHour+' to '+$toHour+'</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <th>'+$include+' day(s)</th>' +
                        '       <td>'+$days+'</td>' +
                        '   </tr>';
                }
            }
        }
        $chtml+= '' +
            '</tbody>'+
            '</table>' +
            '</div>' +
            '</div>';
        return $chtml;
    },
    createCalendarList:function($momentDate, $data){
        var $userId = libs.memoryGet('user_id');
        nurseslounge_myDashboard_schedule.tableBorderCSS(0);
        var $getEvents = nurseslounge_myDashboard_schedule.getEvents($momentDate, $data);
        var $events = $getEvents[0];
        var $currentDay = $getEvents[1];
        var $myCalendar = $("#nurseslounge-home-schedule");
        var $calendar = $myCalendar.find(".calendar:first");
        var $viewMonth = $myCalendar.find(".view-month");
        $viewMonth.hide();
        var $viewWeek = $myCalendar.find(".view-week");
        $viewWeek.hide();
        var $viewDay = $myCalendar.find(".view-day");
        $viewDay.hide();
        var $viewList = $myCalendar.find(".view-list");
        var $viewListThead = $viewList.find('.view-list-thead');
        var $viewListTbody = $viewList.find('.view-list-tbody');
        var $chtml = '';
        $chtml += '' +
            '<tr>' +
            '    <td class="col-12 text-center mt-3" style="border-top:0px;">' +
            '       <b>' +
            $currentDay[1].trace.day.l + ' - ' + $currentDay[1].trace.day.d +
            '       </b>' +
            '   </td>' +
            '</tr>';
        $viewListThead.html($chtml);
        $chtml = '';
        var $carousel = [];
        var $newEvents = 0;
        var $oldEvents = 0;
        var $isTheNext = false;
        for(var $time in $events){
            $carousel.push($time);
            var $list = $events[$time];
            var $currentEvent = moment($time, 'X');
            var $now = moment();
            var $new = $currentEvent > $now;
            if($new){
                $isTheNext = $isTheNext == false ? true : false;
                var $timelineActive = '';
                if($isTheNext){
                    $timelineActive = 'timeline active';
                }
                $newEvents++;
                $chtml += '' +
                    '<div class="col-12 my-5 '+$timelineActive+'">' +
                    '     <div class="view-list-tbody-content right col-5 p-2 mr-4 offset-7">' +
                    '         <div class="view-list-tbody-wrap">';
            }else{
                $oldEvents++;
                $chtml += '' +
                    '<div class="col-12 my-5">' +
                    '    <div class="view-list-tbody-content left col-5 p-2 ml-lg-4">' +
                    '        <div class="view-list-tbody-wrap">';
            }
            //Carousel
            $chtml += '' +
                '<div id="carousel_'+$time+'" class="carousel slide" data-ride="carousel">' +
                '   <div class="carousel-inner">';
            $.each($list, function($i, $v){
                var $listDescription = nurseslounge_myDashboard_schedule.listDescription($v);
                var $key = $v.key;
                var $active =  $i == 0 ? 'active' : '';
                $chtml += '' +
                    '<div class="carousel-item '+$active+'" data-carousel="'+$time+'" data-key="'+$key+'">' +
                    $listDescription +
                    '</div>';
            });
            $chtml += '</div>';
            if($list.length > 1){
                $chtml += '' +
                    '   <a class="carousel-control-prev" href="#carousel_'+$time+'" role="button" data-slide="prev">' +
                    '       <span class="carousel-control-prev-icon" aria-hidden="true"></span>' +
                    '       <span class="sr-only">Previous</span>' +
                    '   </a>' +
                    '   <a class="carousel-control-next" href="#carousel_'+$time+'" role="button" data-slide="next">' +
                    '       <span class="carousel-control-next-icon" aria-hidden="true"></span>' +
                    '       <span class="sr-only">Next</span>' +
                    '   </a>';
            }
            $chtml += '</div>';
            //Carousel end
            $chtml += '</div>' +
                '</div>';
            if($new) {
                $chtml += '' +
                    '     <div class="date right col-3 offset-2 clock" data-startat="'+$time+'">' +
                    '     </div>' +
                    '     <div class="view-list-tbody-img">';
                $.each($list, function($i, $v) {
                    var $key = $v.key;
                    var $image;
                    var $display = $i == 0 ? '' : 'none';
                    if($v.owner_system == 1){
                        $image = '/bimg/Login/small-logo.jpeg';
                    }
                    if($v.ownerUser && $v.ownerUser.email){
                        $image = $v.ownerUser.profile_image_root_friend+'?resize=65';
                    }
                    if($v.ownerLounge && $v.ownerLounge.name){
                        $image = $v.ownerLounge.logo_root_lounge+'?resize=65';
                    }
                    $chtml += '' +
                        '         <img src="' + $image + '" data-carousel="'+$time+'" data-key="'+$key+'" style="display:'+$display+'">';
                });
                $chtml += '' +
                    '     </div>' +
                    ' </div>';
            }else{
                $chtml += '' +
                    '     <div class="date left col-3 offset-7 clock" data-startat="'+$time+'">' +
                    '     </div>' +
                    '     <div class="view-list-tbody-img">';
                $.each($list, function($i, $v) {
                    var $key = $v.key;
                    var $image;
                    var $display = $i == 0 ? '' : 'none';
                    if($v.owner_system == 1){
                        $image = '/bimg/Login/small-logo.jpeg';
                    }
                    if($v.ownerUser && $v.ownerUser.email){
                        $image = $v.ownerUser.profile_image_root_friend+'?resize=65';
                    }
                    if($v.ownerLounge && $v.ownerLounge.name){
                        $image = $v.ownerLounge.logo_root_lounge+'?resize=65';
                    }
                    $chtml += '' +
                        '         <img src="' + $image + '" data-carousel="'+$time+'" data-key="'+$key+'" style="display:'+$display+'">';
                });
                $chtml += '' +
                    '     </div>' +
                    ' </div>';
            }
        }
        $viewListTbody.html($chtml).promise().done(function(){
            var $calendar = $("#nurseslounge-home-my-calendar");
            $.each($carousel, function($i, $v){
                $('#carousel_'+$v).on('slide.bs.carousel', function ($ev) {
                    var $active = $($ev.relatedTarget);
                    var $carousel = $active.data('carousel');
                    var $key = $active.data('key');
                    $(".view-list-tbody-img img[data-carousel='"+$carousel+"']").hide();
                    $(".view-list-tbody-img img[data-key='"+$key+"']").fadeIn();
                }).carousel({
                    interval: 6000,
                    ride:true
                });
            });
            $calendar.find(".view-list-tbody-img img").unbind().click(function(){
                var $that = $(this);
                var $key = $that.data('key');
                //nurseslounge_myDashboard_schedule.getEventModal({key:$key, user_id: $userId});
            });
            $calendar.find(".carousel-item").unbind().click(function(){
                var $that = $(this);
                var $key = $that.data('key');
                //nurseslounge_myDashboard_schedule.getEventModal({key:$key, user_id: $userId});
            });
            libs.checkImageLoad($($chtml).find('img'), function(){
                $viewList.show();
                //var $top = $viewListThead.offset().top - $calendar.offset().top + $viewListThead.height();
                //var $height = $viewListTbody.height() - 10;
                //$('style[data="nurseslounge-home-my-calendar"]').remove();
                //$('<style data="nurseslounge-home-my-calendar">#nurseslounge-home-my-calendar .view-list-tbody::before{height:'+$height+'px;top:'+$top+'px;}</style>').appendTo('head');
                nurseslounge_myDashboard_schedule.createCalendarListClock($newEvents, $oldEvents);
            });
        });
    },
    getEvents:function($momentDate, $data){
        var $events = [];
        var $weeks = nurseslounge_lounge_calendar.getWeeks($momentDate, $data);
        var $week = $momentDate.clone().week();
        var $day = $momentDate.clone().format('DD');
        $day = libs.pad('00',$day,'l');
        var $currentWeek = $weeks.filter(function($v){
            return $v[0] == $week;
        })[0];
        var $_w = $currentWeek[0];
        var $currentDay = $currentWeek[1].filter(function($v){
            return $v[0] == $day;
        })[0];
        var $_day = $currentDay[0];
        var $properties = $currentDay[1];
        var $from = $currentDay[2];
        var $to = moment($from.format('DD-MM-YYYY') + '  23:59:59', 'DD-MM-YYYY HH:mm:ss');
        $.each($properties.events, function($i, $v){
            var $startAt = moment($v.start_at, 'YYYY-MM-DD HH:mm:ss');
            var $endAt = moment($v.end_at, 'YYYY-MM-DD HH:mm:ss');
            if($v.type == 'periodical'){
                if($v.period != 'consecutive' && $v.periodRanges.length > 0){
                    $startAt = $v.periodRanges[$_w][$_day] ? moment($v.periodRanges[$_w][$_day].from_date.trace.date.date, 'YYYY-MM-DD HH:mm:ss') : $startAt;
                    $endAt = $v.periodRanges[$_w][$_day] ? moment($v.periodRanges[$_w][$_day].to_date.trace.date.date, 'YYYY-MM-DD HH:mm:ss') : $endAt;
                }
            }
            var $range = moment().range($from, $to);
            var $_from = moment($v.from, 'YYYY-MM-DD HH:mm:ss');
            if($range.contains($_from)) {
                var $unix = $startAt.clone().format('X');
                if($events[$unix] == undefined){
                    $events[$unix] = [];
                }
                $events[$unix].push($v);
            }
        });
        return [$events, $currentDay];
    },
    tableBorderCSS:function($classBorder){
        $classBorder == undefined ? 1 : $classBorder;
        var $myCalendar = $("#nurseslounge-home-schedule");
        var $calendarTable = $myCalendar.find(".view-list .calendar.table:first");
        var $viewListThead = $calendarTable.find('.view-list-thead');
        if($calendarTable.hasClass('border')){
            if($classBorder == 0){
                $calendarTable.removeClass('border');
            }
        }
        if($viewListThead.hasClass('border')){
            if($classBorder == 0) {
                $viewListThead.removeClass('border');
            }
        }
    },
    listDescription:function($v){
        var $allTimeDay = $v.all_time_day === 1;
        var $fromDay = moment($v.from, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY');
        var $toDay = moment($v.to, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY');
        var $fromHour = moment($v.start_at, 'YYYY-MM-DD HH:mm:ss').format('h:mm A');
        var $toHour = moment($v.end_at, 'YYYY-MM-DD HH:mm:ss').format('h:mm A');
        var $include = $v.include;
        $include = $include ? $include.charAt(0).toUpperCase() + $include.slice(1) : null;
        var $days = $v.days;
        $days = $days ? $days.split(',').join(', ') : '';
        var $color = $v.color;
        var $chtml = '' +
            ' <div class="row px-md-4 py-md-1">' +
            '     <div class="col-md-5 d-none d-md-block d-lg-block col-sm-12 border-right event-info-head text-left"> ';

        if($v.owner_system == 1){
            $chtml +='' +
                '       <h4>Nurses Lounge</h4>';
        }
        if($v.ownerUser && $v.ownerUser.email){
            $chtml +='' +
                '       <h4>'+$v.ownerUser.long_name+'</h4>' +
                '       <h5>'+$v.ownerUser.profile.profile+'</h5>';
        }
        if($v.ownerLounge && $v.ownerLounge.name){
            $chtml +='' +
                '       <h4>'+$v.ownerLounge.name+'</h4>' +
                '       <h5>'+$v.ownerLounge.lounge_type.type+'</h5>';
        }

        $chtml +='' +
            '     </div>' +
            '     <div class="col-md-7 p-sm-0 m-sm-0 event-info-table"> '+
            '       <table>' +
            '           <tbody>';
        if($v.type == 'one_time'){
            $chtml+= '' +
                //'   <tr>' +
                //'       <th>Event Type</th>' +
                //'       <td style="color:'+$color+';">One time event</td>' +
                //'   </tr>' +
                '   <tr>' +
                '       <th>Event Day</th>' +
                '       <td>'+$fromDay+'</td>' +
                '   </tr>';
            if($allTimeDay){
                $chtml+= '' +
                    '   <tr>' +
                    '       <th>Schedule</th>' +
                    '       <td>All Day</td>' +
                    '   </tr>';
            }else{
                $chtml+= '' +
                    '   <tr>' +
                    '       <th>Schedule</th>' +
                    '       <td>'+$fromHour+' to '+$toHour+'</td>' +
                    '   </tr>';
            }
        }
        if($v.type == 'periodical'){
            //$chtml+= '' +
                //'   <tr>' +
                //'       <th>Event Type</th>' +
                //'       <td style="color:'+$color+';">Periodical</td>' +
                //'   </tr>';
            if($v.period == 'consecutive'){
                $chtml+= '' +
                    '   <tr>' +
                    '       <th>Period</th>' +
                    '       <td>Consecutive</td>' +
                    '   </tr>';
                if($allTimeDay){
                    $chtml+= '' +
                        '   <tr>' +
                        '       <th>Duration</th>' +
                        '       <td>'+$fromDay+' to '+$toDay+'</td>' +
                        '   </tr>'+
                        '   <tr>' +
                        '       <th>Schedule</th>' +
                        '       <td>All Day</td>' +
                        '   </tr>';
                }else{
                    $chtml+= '' +
                        '   <tr>' +
                        '       <th>Duration</th>' +
                        '       <td>'+$fromDay+' '+$fromHour+'\n to \n'+$toDay+' '+$toHour+'</td>' +
                        '   </tr>';
                }
            }
            if($v.period == 'no_consecutive'){
                $chtml+= '' +
                    '   <tr>' +
                    '       <th>Period</th>' +
                    '       <td>No Consecutive</td>' +
                    '   </tr>';
                if($allTimeDay){
                    $chtml+= '' +
                        '   <tr>' +
                        '       <th>Duration</th>' +
                        '       <td>'+$fromDay+' to '+$toDay+'</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <th>Schedule</th>' +
                        '       <td>All Day</td>' +
                        '   </tr>';
                }else{
                    $chtml+= '' +
                        '   <tr>' +
                        '       <th>Duration</th>' +
                        '       <td>'+$fromDay+' to '+$toDay+'</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <th>Schedule</th>' +
                        '       <td>'+$fromHour+' to '+$toHour+'</td>' +
                        '   </tr>';
                }
            }
            if($v.period == 'weekly'){
                $chtml+= '' +
                    '   <tr>' +
                    '       <th>Period</th>' +
                    '       <td>Weekly</td>' +
                    '   </tr>';
                if($allTimeDay){
                    $chtml+= '' +
                        '   <tr>' +
                        '       <th>Duration</th>' +
                        '       <td>'+$fromDay+' to '+$toDay+'</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <th>Schedule</th>' +
                        '       <td>All Day</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <th>'+$include+'</th>' +
                        '       <td>'+$days+'</td>' +
                        '   </tr>';
                }else{
                    $chtml+= '' +
                        '   <tr>' +
                        '       <th>Duration</th>' +
                        '       <td>'+$fromDay+' to '+$toDay+'</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <th>Schedule</th>' +
                        '       <td>'+$fromHour+' to '+$toHour+'</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <th>'+$include+'</th>' +
                        '       <td>'+$days+'</td>' +
                        '   </tr>';
                }
            }
            if($v.period == 'monthly'){
                $chtml+= '' +
                    '   <tr>' +
                    '       <th>Period</th>' +
                    '       <td>Monthly</td>' +
                    '   </tr>';
                if($allTimeDay){
                    $chtml+= '' +
                        '   <tr>' +
                        '       <th>Duration</th>' +
                        '       <td>'+$fromDay+' to '+$toDay+'</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <th>Schedule</th>' +
                        '       <td>All Day</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <th>'+$include+' day(s)</th>' +
                        '       <td>'+$days+'</td>' +
                        '   </tr>';
                }else{
                    $chtml+= '' +
                        '   <tr>' +
                        '       <th>Duration</th>' +
                        '       <td>'+$fromDay+' to '+$toDay+'</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <th>Schedule</th>' +
                        '       <td>'+$fromHour+' to '+$toHour+'</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <th>'+$include+' day(s)</th>' +
                        '       <td>'+$days+'</td>' +
                        '   </tr>';
                }
            }
        }
        $chtml+= '' +
            '           </tbody>'+
            '       </table>' +
            '   </div>' +
            '</div>';
        return $chtml;
    },
    createCalendarListClock:function($newEvents, $oldEvents){
        var $userId = libs.memoryGet('user_id');
        var $calendarClockBinding = libs.memoryGet('myDashboard_schedule_calendar_clock_binding') ? libs.memoryGet('myDashboard_schedule_calendar_clock_binding') : null;
        var $now = moment();
        var $myCalendar = $("#nurseslounge-home-schedule");
        var $viewList = $myCalendar.find(".view-list");
        var $viewListTbody = $viewList.find('.view-list-tbody');
        var $news = 0;
        var $olds = 0;
        $viewListTbody.find('.clock').each(function($i, $v){
            var $dateString = [];
            var $that = $(this);
            var $startat = $that.data('startat');
            var $date = moment.unix($startat);
            var $sense = $date.clone().diff($now, 'seconds') > 0;
            var $diffSeconds = $sense ? $date.clone().diff($now, 'seconds') : $now.clone().diff($date, 'seconds');
            var $diffMinutes = $sense ? $date.clone().diff($now, 'minutes') : $now.clone().diff($date, 'minutes');
            var $diffHours = $sense ? $date.clone().diff($now, 'hours') : $now.clone().diff($date, 'hours');
            var $diffDays = $sense ? $date.clone().diff($now, 'days') : $now.clone().diff($date, 'days');
            var $diffMonths = $sense ? $date.clone().diff($now, 'months') : $now.clone().diff($date, 'months');
            var $diffYears = $sense ? $date.clone().diff($now, 'years') : $now.clone().diff($date, 'years');
            var $years = parseInt($diffYears);
            var $monthsHelper = $sense ? $date.clone().subtract($diffYears, 'years') : $date.clone().add($diffYears, 'years');
            var $months = $now.clone().diff($monthsHelper, 'months');
            $months = parseInt($months);
            $months = $months > 0 ? $months : (-1 * $months);
            $months = $months > 0 ? $months == 1 ? $months+' month' : $months+' months'  : '';
            $dateString.push($months);
            var $daysHelper = $sense ? $date.clone().subtract($diffMonths, 'months') : $date.clone().add($diffMonths, 'months');
            var $days = $now.clone().diff($daysHelper, 'days');
            $days = parseInt($days);
            $days = $days > 0 ? $days : (-1 * $days);
            $days = $days > 0 ? $days == 1 ? $days+' day' : $days+' days'  : '';
            $dateString.push($days);
            var $hoursHelper = $sense ? $date.clone().subtract($diffDays, 'days') : $date.clone().add($diffDays, 'days');
            var $hours = $now.clone().diff($hoursHelper, 'hours');
            $hours = parseInt($hours);
            $hours = $hours > 0 ? $hours : (-1 * $hours);
            $hours = $hours > 0 ? $hours == 1 ? $hours+' hour' : $hours+' hours'  : '';
            $dateString.push($hours);
            var $minutesHelper = $sense ? $date.clone().subtract($diffHours, 'hours') : $date.clone().add($diffHours, 'hours');
            var $minutes = $now.clone().diff($minutesHelper, 'minutes');
            $minutes = parseInt($minutes);
            $minutes = $minutes > 0 ? $minutes : (-1 * $minutes);
            $minutes = $minutes > 0 ? $minutes == 1 ? $minutes+' minute' : $minutes+' minutes'  : '';
            $dateString.push($minutes);
            var $secondsHelper = $sense ? $date.clone().subtract($diffMinutes, 'minutes') : $date.clone().add($diffMinutes, 'minutes');
            var $seconds = $now.clone().diff($secondsHelper, 'seconds');
            $seconds = parseInt($seconds);
            $seconds = $seconds > 0 ? $seconds : (-1 * $seconds);
            $seconds = $seconds > 0 ? $seconds == 1 ? $seconds+' second' : $seconds+' seconds'  : '';
            $dateString.push($seconds);
            if($days > 3){
                $that.html($date.format('YYYY-MM-DD HH:mm:ss'));
            }else{
                if($sense){
                    $news++;
                    $that.html('start in ' + $dateString.join(' '));
                }else{
                    $olds++;
                    $that.html($dateString.join(' ') + ' ago');
                }
            }
        });
        if($newEvents != $news && $oldEvents != $olds){
            var $timeZone = $myCalendar.find(".time-zone");
            var $area = $timeZone.data('area');
            var $params = $.extend({}, {user_id:$userId, area:$area, week:$now.clone().format('DD-MM-YYYY')});
            nurseslounge_myDashboard_schedule.get($params, function($data){
                nurseslounge_myDashboard_schedule.createCalendar('list', $now.clone(), $data);
            });
        }
        try{
            clearTimeout($calendarClockBinding);
        }catch ($e) {

        }
        $calendarClockBinding = setTimeout(function(){
            nurseslounge_myDashboard_schedule.createCalendarListClock($newEvents, $oldEvents);
        }, 1000);
        libs.memorySave('myDashboard_schedule_calendar_clock_binding', $calendarClockBinding);
    },
    //Checklist
    /*
    openPreviousEvent:function($params){
        var $modal = $("#home-my-profile-calendar-events-checklist");
        var $modalBody = $modal.find('.modal-body');
        nurseslounge_myDashboard_schedule.openPreviousEventRequest($params, function($chtml){
            $modalBody.html($chtml).promise().done(function(){


                $modal.modal('show');
            });
        });
    },
    openPreviousEventRequest:function($params, cback){
        $.ajax({
            url: "/myDashboard/myCalendar/getChecklist",
            method: 'POST',
            cache: false,
            dataType: "html",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    }
    */
};
